/* 08-10: direct checkout ONLY when the Kaching deal variant shown to this visitor has "Skip cart" ON (A/B test: B=skip, A=cart) */
window.WH_DIRECT = function () { try { var b = document.querySelector('.kaching-bundles__block[data-ab-test-variant-id]'); if (!b) return false; var id = b.getAttribute('data-ab-test-variant-id'), ok = false; document.querySelectorAll('script[type="application/json"]').forEach(function (s) { var t = s.textContent; if (t.indexOf(id) > -1 && t.indexOf('"skipCart":true') > -1) ok = true; }); return ok; } catch (e) { return false; } };
/* ==========================================================================
   WILDHORN DARK : CART DRAWER  (assets/wh1-cart.js, CART builder)
   1:1 port of the approved preview drawer (/root/workspace/wildhorn-lp/site/assets-src/cart.js + cart.css),
   driven by the REAL Shopify cart (/cart.js). Mount + config: snippets/wh-cart-drawer.liquid
   (<div id="whc"> and <script type="application/json" id="whc-cfg">). Styles: assets/wh1-cart.css.
   Source of truth: /root/workspace/wildhorn-lp/shopify-dark/cartwork/wh1-cart.js (deploy: build_cart.py deploy).

   Kept from the previous drawer (the light 'GENERIC AJAX CART DRAWER' snippet):
     - add-to-cart detection: window.fetch (string URL and Request), XMLHttpRequest, native
       <form action="/cart/add"> submit, cart links / [data-cart-open] (capture), 'cart:open' event
     - free gift auto add + orphan strip (ensureGifts) and optional shipping protection (ensureShipping)
     - checkout = /checkout ; window.cdOpen / cdOpenLoading / cdClose / cdRefresh / cdChangeQty / cdRemoveKeys
   Kaching bundles (line property __kaching_bundles, same "id" on the paid line, the $0 free jar line and the
   gift line) are shown as ONE bundle line, like the preview. Changing the jar count in the drawer (plus / minus,
   upgrade card) adds the same bundle again with the Kaching bar of the new size (same deal, A/B variant,
   selling plan and properties), then removes the old lines: Kaching prices it exactly like the product page
   (tested 2026-09-26: 2 jars $49.95 -> 3 jars $69.90 -> 1 jar $49.99, one-time 3 jars $159.80 on B).
   Bar ids + prices: Kaching settings read on the product page (cached in localStorage 'whc_kdeals'),
   else the snapshot in the snippet config. If no bar is known, the button opens the product page offer.
   Copy rule (Adrien 2026-09-26): the cart never names the plan (no plan words, no selling plan names).
   API: window.WHCart.open(), .close(), .refresh(), .get() (last /cart.js), .model(), .pending()

   INSTANT CART (27-09, Adrien "accelere le chargement du panier"). Product page facade only (window.WH1P):
     - click on #atc / .sb6__btn / .fo__atc (the final offer mirror forwards to #atc): the drawer opens at the next
       frame with the chosen line built from WH1P.state() + WH1P.T and the SAME markup as the real render
       (lineHTML, gifts, upgrade card). Checkout stays disabled (is-pending) until the real cart is rendered.
     - the add request (hook below) starts before any drawer work; its response triggers ONE /cart.js, then the
       real cart replaces the optimistic one by patching (unchanged blocks keep their nodes: no jump, no rebuild).
     - failed add (non OK status, network error, or no request within 4 s): the previous cart view comes back
       with a short error message in the drawer.
     - while the drawer is closed, the line for the current offer is pre-rendered (hidden, inert) when the page
       is idle, so the click only flips classes. Reason: on this page ANY node insertion or text node swap
       restyles the whole document (~2000 elements, ~95 ms at 4x CPU) because of the :has() rules of the base
       theme and apps; class, attribute and text data changes stay cheap. The render path below therefore patches
       (text data, attributes) instead of rebuilding, and never forces a layout read.
     Pages without WH1P: same flow as before (loading skeleton, then /cart.js).
   ========================================================================== */
(function () {
  'use strict';
  if (window.WHCart && window.WHCart.shopify) return;
  var d = document, W = window;
  var CFG = {};
  try { CFG = JSON.parse((d.getElementById('whc-cfg') || {}).textContent || '{}') || {}; } catch (e) { CFG = {}; }
  var GIFT_H = CFG.giftHandles || [];
  var SHIP_H = CFG.shipOn ? (CFG.shipHandle || '') : '';
  var HIDDEN = GIFT_H.concat(CFG.shipHandle ? [CFG.shipHandle] : []);
  var IMG = CFG.img || {};
  /* 19/10 PANIER v2 (Adrien): product line thumbnail = the product page's FIRST gallery image (jar on the sunset/bison scene).
     Source = the cart line image (/cart.js: the product's featured image = first gallery image, it follows the product if the
     gallery changes); HERO = same file, only for the instant (optimistic) line before /cart.js answers. 128px for a 64px box. */
  var HERO = IMG.hero || 'https://cdn.shopify.com/s/files/1/0839/1530/9300/files/wildhorn-bison-organs-jar-hero.jpg?v=1790539639', heroSeen = {};
  function heroFor(g) {
    if (g.image) heroSeen[g.handle] = g.image;
    var u = g.image || heroSeen[g.handle] || HERO;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=128';
  }
  /* 19/10 PANIER v2: the gifts bar grows in ONCE per opening of the drawer. open() arms it (t19want), the first render that has the
     bar starts ONE Web Animation on that node (its max-width, 45% -> 100% of its fill: the bar gets longer, its rounded end and its
     stripes keep their shape; max-width, not width, so it never fights the live width transition), close() disarms it. A later render while open (stepper, upgrade,
     remove, undo, gifts check) never restarts it, even when the bar node is rebuilt: the bar then only moves with the live width
     transition. Off with prefers-reduced-motion. */
  var t19want = false, t19A = null;
  function t19grow(bar, to) {
    try {
      if (!bar.animate || (W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      if (t19A) t19A.cancel();
      var f = parseFloat(to);
      if (!(f > 0)) return;
      t19A = bar.animate([{ maxWidth: (f * .45).toFixed(2) + '%' }, { maxWidth: f + '%' }], { duration: 1300, delay: 350, easing: 'cubic-bezier(.3,.7,.2,1)', fill: 'backwards' });
      W.__whcGrow = (W.__whcGrow || 0) + 1;   /* count of grows (tests) */
    } catch (e) { }
  }
  /* a render while the grow still runs (a tap on +, -, upgrade, remove or undo, or the gifts check, in the first 1.7 s of an opening):
     the grow stops and the bar starts from where it is on screen (its drawn width / the track's), then only the live width transition
     moves it, in the direction of the change: it never jumps ahead and comes back. One layout read, only in that case. */
  function t19cutNow() {
    var a = t19A; t19A = null;
    if (!a || a.playState !== 'running') return null;
    var el = a.effect && a.effect.target, v = 0;
    try { if (el && el.isConnected && el.parentNode) { var tw = el.parentNode.getBoundingClientRect().width; if (tw > 0) v = el.getBoundingClientRect().width / tw * 100; } } catch (e) { }
    try { a.cancel(); } catch (e) { }
    W.__whcCut = (W.__whcCut || 0) + 1;   /* count of cut grows (tests) */
    return v > 0 ? Math.min(100, v).toFixed(2) + '%' : null;
  }
  /* 19/10 PANIER v2: style overrides of assets/wh1-cart.css (one <style> after it, injected once) */
  var T19CSS = '/* ===== 19/10 PANIER v2 (Adrien) : overrides of assets/wh1-cart.css (38f8f1c44444), injected by wh1-cart.js (style#whc-t19) ===== */' +
    '/* 1 product line: compact, centered, first gallery image */' +
    '#whc.whc .whc__it:not(.whc__gd){grid-template-columns:64px minmax(0,1fr);gap:12px;padding:10px 12px 10px 10px;align-items:center;border-radius:12px}' +
    '#whc.whc .whc__it:not(.whc__gd)>.whc__im{width:64px;height:64px;border-radius:10px;overflow:visible;background:none;border:0}' +
    '#whc.whc .whc__it .whc__hero{display:block;box-sizing:border-box;width:64px;height:64px;border-radius:10px;object-fit:cover;border:1px solid rgba(232,220,196,.14);background:#1C1511}' +
    '/* "2x" badge (same text and colours as live) on the thumbnail\'s corner, so it does not cover the jar */' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__qb{left:-7px;top:-7px;height:22px;line-height:18px;border:2px solid #18130F;box-sizing:border-box}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__tp{align-items:center}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__tt{font-size:14px;line-height:1.15}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__rm{width:30px;height:30px;margin:-7px -6px -7px auto}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__rm svg{width:16px;height:16px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__mt{margin-top:5px}' +
    '#whc.whc .whc__it.whc__itb .whc__mt{display:none}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__dl{padding:4px 8px;font-size:9.5px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__bt{margin-top:0;padding-top:7px;align-items:center;gap:8px}' +
    '#whc.whc .whc__it.whc__itb .whc__bt{padding-top:6px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__q{height:32px;border-radius:9px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__q button{width:32px;height:30px;border-radius:8px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__q button svg{width:13px;height:13px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__q span{min-width:44px;font-size:12.5px}' +
    '/* B: the "1 jar" count = the box, font, size and colour of A\'s "2 jars" (rules above), without the - / + buttons */' +
    '#whc.whc .whc__it.whc__itb .whc__q span{padding:0 12px}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__pr{margin-left:auto}' +
    '#whc.whc .whc__it:not(.whc__gd) .whc__pr b{font-size:16.5px;line-height:1.1;letter-spacing:0}' +
    '/* loading placeholder = same box as the compact line (no jump when the real line comes in) */' +
    '#whc.whc .whc__ld{grid-template-columns:64px minmax(0,1fr);gap:12px;padding:10px 12px 10px 10px;border-radius:12px}' +
    '#whc.whc .whc__ldi{width:64px;height:64px;border-radius:10px}' +
    '/* 2 guide line = coupon: small green dashes, drawn by an SVG stroke (1.5px in every browser; Chrome rounds a 1.5px CSS border to 1px) */' +
    '#whc.whc .whc__it.whc__gd{border:1px solid transparent;border-radius:12px;background:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'100%25\' height=\'100%25\' rx=\'12\' ry=\'12\' fill=\'none\' stroke=\'%238FD6A0\' stroke-opacity=\'.9\' stroke-width=\'3\' stroke-dasharray=\'6%204\'/%3E%3C/svg%3E") 0 0/100% 100% no-repeat border-box,linear-gradient(180deg,rgba(127,207,143,.10),rgba(127,207,143,.04)) border-box}' +
    '/* 4 TOTAL row: smaller; footer spacing tightened so the footer is not taller than live and the TOTAL row does not move up */' +
    '#whc.whc .whc__ft{padding-top:10px;padding-bottom:calc(9px + env(safe-area-inset-bottom,0px))}' +
    '#whc.whc .whc__tl{font-size:12.5px;letter-spacing:.12em}' +
    '#whc.whc .whc__sp{font-size:11.5px;margin-top:2px}' +
    '#whc.whc .whc__tv b{font-size:19px;letter-spacing:0}' +
    '/* 5 checkout button: no price; the arrow stays on phones <=360px (live hid it there to make room for the price) */' +
    '#whc.whc .whc__ft .whc__co{margin-top:7px}' +
    '@media (max-width:360px){#whc.whc .whc__co .whc__ar{display:inline-block}}' +
    '/* 6 reviews line under the button */' +
    '#whc.whc .whc__rvl{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:3px 7px;margin-top:6px;font:500 12px/1.2 var(--w-sans);color:var(--w-mute);text-align:center}' +
    '#whc.whc .whc__rvl b{color:#fff;font-weight:700}' +
    '#whc.whc .whc__rvst{color:#F2C14E;letter-spacing:1.5px;font-size:12px;line-height:1}' +
    '#whc.whc .whc__rvd{width:3px;height:3px;border-radius:50%;background:var(--w-dim);flex:none}' +
    '/* 7 trust row: live words and sizes, tighter spacing */' +
    '#whc.whc .whc__ft .whc__tb{margin-top:6px}' +
    '#whc.whc .whc__tb li{gap:4px!important;line-height:1.2}' +
    '/* short screens (live tightens its footer there too): tighter gaps; very short: like the trust row, the reviews line steps aside */' +
    '@media (max-height:700px){#whc.whc .whc__ft{padding-bottom:calc(8px + env(safe-area-inset-bottom,0px))}#whc.whc .whc__ft .whc__co{margin-top:5px}#whc.whc .whc__rvl{margin-top:4px}#whc.whc .whc__ft .whc__tb{margin-top:4px}}' +
    '@media (max-height:560px){#whc.whc .whc__rvl{display:none}}' +
    '/* 8 gifts progress bar: more visible + animated stripes while the drawer is open. The grow is ONE Web Animation per opening,' +
    '   started by the JS on the bar node (t19grow), never by a class: a re-render while open only moves the bar with the width transition */' +
    '#whc.whc .whc__trk{height:8px;background:rgba(232,220,196,.15)}' +
    '#whc.whc .whc__stp{margin-top:-22px}' +
    '#whc.whc .whc__trk i{overflow:hidden;background:linear-gradient(90deg,#3FA75A,#8EE5A1);transform-origin:0 50%}' +
    '#whc.whc .whc__trk i::after{content:"";position:absolute;top:0;bottom:0;left:-12px;right:0;background:linear-gradient(135deg,rgba(255,255,255,.34) 25%,rgba(255,255,255,0) 25%,rgba(255,255,255,0) 50%,rgba(255,255,255,.34) 50%,rgba(255,255,255,.34) 75%,rgba(255,255,255,0) 75%) 0 0/12px 12px}' +
    '#whc.whc.is-open .whc__trk i::after{animation:whcT19st .75s linear infinite;will-change:transform}' +
    '@keyframes whcT19st{to{transform:translateX(12px)}}' +
    '@media (prefers-reduced-motion:reduce){#whc.whc .whc__trk i::after,#whc.whc .whc__trk i{animation:none!important}}';
  try { if (!d.getElementById('whc-t19')) { var t19 = d.createElement('style'); t19.id = 'whc-t19'; t19.textContent = T19CSS; (d.head || d.documentElement).appendChild(t19); } } catch (e) { }
  /* 19/10 FIX B4 (Adrien: the checkout arrow shakes on tap). Live: :hover brightness filter (.15s) + :active translateY(1px) (.12s)
     = the arrow slides and blurs by a subpixel on every tap. Now the SECURE CHECKOUT button never moves and never runs a filter;
     press = instant darker orange; mouse hover (computers only) = instant lighter orange, the live brightness(1.04) as colours.
     One <style> after assets/wh1-cart.css, injected once: the fix stays inside this ONE asset. */
  var B19CSS = '#whc.whc button.whc__co.whc__co,#whc.whc button.whc__co.whc__co:hover,#whc.whc button.whc__co.whc__co:active,#whc.whc button.whc__co.whc__co.is-go{transition:none!important;transform:none!important;filter:none!important}' +
    '@media (hover:hover) and (pointer:fine){#whc.whc button.whc__co.whc__co:hover{background:linear-gradient(180deg,#FA7F3E 0%,#D14B20 100%)!important}}' +
    '#whc.whc button.whc__co.whc__co:active{background:linear-gradient(180deg,#E06A2E 0%,#B83F1A 100%)!important}' +
    '#whc.whc .whc__co>svg,#whc.whc .whc__co .whc__ar{flex:none;transition:none!important;transform:none!important}';
  try { if (!d.getElementById('whc-b19')) { var b19 = d.createElement('style'); b19.id = 'whc-b19'; b19.textContent = B19CSS; (d.head || d.documentElement).appendChild(b19); } } catch (e) { }
  /* 20/10 R1 FIX T1: +, -, upgrade and trash take taps while a change is saving (queued, see qTap); still not while an add is pending
     (is-pending). Was: pointer-events:none for the whole save (1.5 to 2.5 s on a phone far from the US): the tap was lost. */
  try { if (!d.getElementById('whc-t20')) { var t20 = d.createElement('style'); t20.id = 'whc-t20'; t20.textContent = '#whc.whc.is-busy:not(.is-pending) .whc__q button,#whc.whc.is-busy:not(.is-pending) .whc__upb,#whc.whc.is-busy:not(.is-pending) .whc__rm{pointer-events:auto}'; (d.head || d.documentElement).appendChild(t20); } } catch (e) { }
  /* 20/10 R2 FIX A2: a page add still out (no instant view): the pending look stays, the lines take taps (queued, FIX T1) */
  try { if (!d.getElementById('whc-t21')) { var t21 = d.createElement('style'); t21.id = 'whc-t21'; t21.textContent = '#whc.whc.is-pending.whc-pq .whc__q button,#whc.whc.is-pending.whc-pq .whc__upb,#whc.whc.is-pending.whc-pq .whc__rm{pointer-events:auto}'; (d.head || d.documentElement).appendChild(t21); } } catch (e) { }
  var HOLD = 'wh_cart_hold', HOLD_MS = 10 * 60 * 1000, KKEY = 'whc_kdeals', SHIPKEY = 'cd_ship_protect';
  var TIERS = [
    { deal: '', jars: 1, days: 15 },
    { deal: 'Buy 1, Get 1 FREE', jars: 2, days: 30 },
    { deal: 'Buy 2, Get 1 FREE', jars: 3, days: 45 }
  ];
  /* same rows as the GIFTS UNLOCKED box on the product page. The Guide row = the Kaching gift line
     (the-testosterone-protocol-free-gift); Shipping and Mystery Gift are display rows (bundle size + plan). */
  var GIFTS = [
    { need: 1, name: 'US Shipping', step: 'US Shipping', sub: 'Ships in 1 business day', img: IMG.parcel, value: 0 },
    { need: 2, name: 'Testosterone Support Guide', step: '$29 Guide', sub: 'Included with your order', img: IMG.ebook, value: 2900 },
    { need: 3, name: 'Mystery Gift', step: 'Mystery Gift', sub: 'A surprise from the herd', img: IMG.mystery, value: 0 }
  ];
  var FILL = ['0%', '16.7%', '50%', '100%'];
  var GUIDE_AT_1 = false;   /* 20/10 FINAL FIX G2 (owner 20/10: guide only from 2 jars, as the page promises; see ensureGifts). true = the v2 rule (guide from 1 jar) */
  var PAY = [['visa', 'Visa'], ['mastercard', 'Mastercard'], ['amex', 'American Express'], ['apple-pay', 'Apple Pay'], ['google-pay', 'Google Pay'], ['shop-pay', 'Shop Pay']];
  var IC = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="13.5" r="7.5"/><path d="M12 10v3.8l2.4 1.6M9.5 2.8h5"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2.4" fill="currentColor"/><path d="M8.3 10.5V8.2a3.7 3.7 0 0 1 7.4 0v2.3" fill="none" stroke="currentColor" stroke-width="2.4"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9.5H4zM3 7.5h18V11H3zM12 7.5v13" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M12 7.5C10.5 4 7 3.6 7 5.6 7 7.2 9.5 7.5 12 7.5zM12 7.5c1.5-3.5 5-3.9 5-1.9 0 1.6-2.5 1.9-5 1.9z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" fill="currentColor"/><circle cx="17" cy="17" r="1.8" fill="currentColor"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.2-7.5 9.5-4.3-1.3-7.5-4.9-7.5-9.5V6z"/><path d="M8.8 12.2l2.3 2.3 4.3-4.6" stroke-linecap="round"/></svg>',
    padlock: '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true"><path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>',
    arrow: '<svg class="whc__ar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>',
    bison: '<svg class="whc__bx" viewBox="0 0 512 512" aria-hidden="true"><use href="#bisonx"/></svg>'
  };

  /* Pristine fetch captured BEFORE window.fetch is overridden: every internal cart call uses it. */
  /* 20/10 R1 FIX X1 (two tabs): every cart write of this page (drawer, gifts pass, page adds) stamps localStorage whc_cw; each /cart.js
     read remembers the stamp it was asked under. A stamp from another tab newer than this tab's last read = what this tab shows may be
     stale: an open drawer reads the cart ('storage' event, tab shown again), a +, -, upgrade or trash reads it first and acts on the
     line it shows now (FIX T1 path), checkout reads it first (FIX C2). Never an update.js with the line keys of another cart state
     (Shopify then hits the first line of that variant: a stale 2 jars, + = 1 jar for $49). */
  var CWK = 'whc_cw', cwMine = '', cwSeen = '';
  function cwGet() { try { return localStorage.getItem(CWK) || ''; } catch (e) { return ''; } }
  function cwBump() { cwMine = Date.now().toString(36) + rid(); try { localStorage.setItem(CWK, cwMine); } catch (e) { } }
  function cwOther() { var v = cwGet(); return !!v && v !== cwSeen && v !== cwMine; }
  var fetch0 = W.fetch.bind(W);
  var origFetch = function (a, o) {
    try { var u = typeof a === 'string' ? a : (a && a.url) || '', mt = (o && o.method) || (a && typeof a === 'object' && a.method) || ''; if (/^post$/i.test(mt) && /\/cart\/(add|change|update|clear)/.test(u)) cwBump(); } catch (e) { }
    return fetch0.apply(W, arguments);
  };
  var cart = CFG.cart && CFG.cart.items ? CFG.cart : null;   /* last known Shopify cart */
  var busy = 0;                      /* internal cart writes in flight */
  var ensureGiftsRunning = false, ensureShipRunning = false;

  /* ---- helpers ---- */
  function money(c) {
    var iso = (W.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var amt = (Math.abs(c || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (iso === 'GBP') return '£' + amt;
    if (iso === 'EUR') return '€' + amt;
    if (iso === 'AUD' || iso === 'CAD' || iso === 'NZD') return iso + ' $' + amt;
    return '$' + amt;
  }
  function jarsWord(n) { return n + (n === 1 ? ' jar' : ' jars'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function assign(t) { for (var i = 1; i < arguments.length; i++) { var s = arguments[i]; if (s) for (var k in s) if (Object.prototype.hasOwnProperty.call(s, k)) t[k] = s[k]; } return t; }
  function isHidden(h) { return HIDDEN.indexOf(h) > -1; }
  function isGift(h) { return GIFT_H.indexOf(h) > -1; }
  function kp(it) {
    var p = it && it.properties && it.properties.__kaching_bundles;
    if (!p) return null;
    if (typeof p === 'object') return p;
    try { return JSON.parse(p); } catch (e) { return null; }
  }
  function spOf(it) { var a = it && it.selling_plan_allocation; return a && a.selling_plan ? a.selling_plan.id : null; }
  /* price per unit before any deal: the one-time price (a plan line carries it as compare_at_price) */
  function unitWas(it) {
    var a = it.selling_plan_allocation;
    return Math.max(a && a.compare_at_price || 0, it.original_price || 0, (CFG.compareCaps || {})[it.handle] || 0);
  }
  function rid() { var a = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_', s = ''; for (var i = 0; i < 4; i++) s += a[Math.floor(Math.random() * a.length)]; return s; }
  function jget(u) { return origFetch(u, { headers: { 'Accept': 'application/json' }, cache: 'no-store', credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function post(u, body) {
    return origFetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error(j && (j.description || j.message) || r.status); e.status = r.status; throw e; } return j; }); });
  }
  var rdN = 0;   /* 19/10 FIX B2: /cart.js reads in flight (a B checkout waits for them: the guard starts from their answer) */
  /* 20/10 FIX S1 (stale /cart.js answers). Every answer carries the order it was asked in (__s) and the write generation of that
     moment (__g). wg moves when a cart write starts (a drawer change, a page add, a swap repair). setCart() never applies an answer
     asked before the newest write started, nor one older than the newest answer already applied: the drawer and the badge only move
     forward (a late answer to the header icon's read, a gifts pass or the page-load read can no longer bring back a removed line). */
  var rdSeq = 0, okSeq = 0, wg = 0;
  function wBump() { wg++; reqN++; }
  function stale(c) { return !!(c && c.__s && (c.__s < okSeq || c.__g !== wg)); }
  function fetchCart() {
    rdN++; var s = ++rdSeq, g = wg, cw = cwGet(), dn = function () { rdN--; };   /* 20/10 R1 FIX X1: + the write stamp of that moment */
    var p = jget('/cart.js').then(function (c) { if (c && typeof c === 'object') try { Object.defineProperty(c, '__s', { value: s }); Object.defineProperty(c, '__g', { value: g }); Object.defineProperty(c, '__cw', { value: cw }); } catch (e) { } return c; });
    p.then(dn, dn); return p;
  }

  /* ---- cheap DOM updates (see INSTANT CART above): text data, attributes, keyed blocks ---- */
  var tpl = d.createElement('template');
  function parse(h) { tpl.innerHTML = h; var n = [].slice.call(tpl.content.childNodes); tpl.innerHTML = ''; return n; }
  function sameShape(a, b) {
    if (a.nodeType !== b.nodeType) return false;
    if (a.nodeType !== 1) return true;
    if (a.nodeName !== b.nodeName) return false;
    var ac = a.childNodes, bc = b.childNodes;
    if (ac.length !== bc.length) return false;
    for (var i = 0; i < ac.length; i++) if (!sameShape(ac[i], bc[i])) return false;
    return true;
  }
  /* a and b have the same shape: copy text data and attributes of b onto a */
  function morph(a, b) {
    if (a.nodeType !== 1) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
    var i, at, aa = a.attributes, ba = b.attributes;
    for (i = aa.length - 1; i >= 0; i--) { at = aa[i]; if (!b.hasAttribute(at.name)) a.removeAttribute(at.name); }
    for (i = 0; i < ba.length; i++) { at = ba[i]; if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value); }
    for (i = 0; i < a.childNodes.length; i++) morph(a.childNodes[i], b.childNodes[i]);
  }
  /* children of el = html h: morph when the shape is the same (no form fields), else rebuild */
  function setHTML(el, h) {
    if (el.__h === h) return;
    var old = el.__h; el.__h = h;
    if (old != null && h && h.indexOf('<input') < 0) {
      var nn = parse(h), oc = el.childNodes, ok = nn.length === oc.length, i;
      for (i = 0; ok && i < nn.length; i++) ok = sameShape(oc[i], nn[i]);
      if (ok) { for (i = 0; i < nn.length; i++) morph(oc[i], nn[i]); return; }
    }
    el.innerHTML = h;
  }
  /* text of el: change the text node data (cheap) instead of replacing the node */
  function setText(el, s) {
    s = String(s);
    var f = el.firstChild;
    if (f && f.nodeType === 3 && !f.nextSibling) { if (f.data !== s) f.data = s; }
    else if (el.textContent !== s) el.textContent = s;
  }
  /* keyed blocks of el: list = [{k: key, h: html}]. Same html = same nodes; same shape = morph; else new nodes. */
  function patch(el, list) {
    var old = el.__s || [], om = {}, next = [], i, j, s, o, nodes, k;
    for (i = 0; i < old.length; i++) om[old[i].k] = old[i];
    for (i = 0; i < list.length; i++) {
      s = list[i]; o = om[s.k]; nodes = null;
      if (o && o.nodes.every(function (n) { return n.parentNode === el; })) {
        if (o.h === s.h) nodes = o.nodes;
        else {
          var nn = parse(s.h);
          if (nn.length === 1 && o.nodes.length === 1 && sameShape(o.nodes[0], nn[0])) { morph(o.nodes[0], nn[0]); nodes = o.nodes; }
        }
        if (nodes) delete om[s.k];
      }
      next.push({ k: s.k, h: s.h, nodes: nodes });
    }
    for (k in om) om[k].nodes.forEach(function (n) { if (n.parentNode === el) el.removeChild(n); });
    var ref = el.firstChild;
    for (i = 0; i < next.length; i++) {
      if (!next[i].nodes) next[i].nodes = parse(next[i].h);
      nodes = next[i].nodes;
      for (j = 0; j < nodes.length; j++) {
        if (nodes[j] === ref) ref = ref.nextSibling;
        else el.insertBefore(nodes[j], ref);
      }
    }
    while (ref) { var nx = ref.nextSibling; el.removeChild(ref); ref = nx; }
    el.__s = next;
  }

  /* ---- Kaching deal settings (bar ids + bar prices) ---- */
  var kMem = {};
  function slimBar(b) {
    var bx = b.dealBarType === 'bxgy';
    var n = bx ? (+b.buyQuantity || 0) + (+b.getQuantity || 0) : +b.quantity || 0;
    if (!b.id || !n) return null;
    var o = {
      id: b.id, n: n, buy: bx ? +b.buyQuantity : n, get: bx ? +b.getQuantity : 0,
      dt: bx ? b.buyDiscountType : b.discountType, dv: bx ? b.buyDiscountValue : b.discountValue,
      gdt: b.getDiscountType || null, gdv: b.getDiscountValue == null ? null : b.getDiscountValue,
      gifts: (b.freeGifts || []).filter(function (g) { return g.giftType === 'product' && g.productGID; })
        .map(function (g) { return { id: g.id, pid: +String(g.productGID).split('/').pop(), q: g.quantity || 1 }; })
    };
    var sp = b.sellingPlanEnabled && b.sellingPlanGid ? +String(b.sellingPlanGid).split('/').pop() : 0;
    if (sp > 0) o.sp = sp;   /* 23/10 B/C F3: the bar's own selling plan (arm B: 1 / 2 / 3 jars = every 30 / 60 / 90 days). None = no key */
    return o;
  }
  function kParse(root) {
    var out = {};
    [].forEach.call(root.querySelectorAll('script.kaching-bundles-deal-block-settings'), function (s) {
      try {
        var j = JSON.parse(s.textContent), bars = (j.dealBars || []).map(slimBar).filter(Boolean);
        if (bars.length) out[j.abTestVariantId || j.versionId || j.id] = { deal: j.nanoId, ab: j.abTestVariantLetter || '', pid: +s.getAttribute('data-product-id') || 0, bars: bars,
          v: j.versionId || '', abid: j.abTestVariantId || '', pre: j.preselectedDealBarId || '', t: Date.now(), rg: j.abTestVariantRange || null };   /* OFFER B: rg = arm range */
      } catch (e) { }
    });
    return out;
  }
  function kStore() { try { return JSON.parse(localStorage.getItem(KKEY)) || {}; } catch (e) { return {}; } }
  function kHarvest() {
    var f = kParse(d), n = 0;
    for (var k in f) { kMem[k] = f[k]; n++; }
    if (n) try { localStorage.setItem(KKEY, JSON.stringify(assign(kStore(), f))); } catch (e) { }
  }
  /* 20/10 R4 FIX K1 (neverB B1): the deal settings of a cart line = those of ITS Kaching version and A/B arm only: this page's live
     settings (kMem), then the copy harvested on the product page (localStorage), then the theme snapshot (CFG.kaching) only for an
     arm it holds. Was: any deal with the same id, the stale snapshot first (3 bars, old prices): a 1-bar line got a "2nd jar FREE"
     card and + built a 2-jar bundle on a bar its deal does not have; on other pages a current line showed the snapshot's prices.
     Not known here (or only an old copy): the product page's live settings are read once (kNeed), the drawer redraws then. */
  function kDeal(P) {
    if (!P) return null;
    var src = [kMem, kStore(), CFG.kaching || {}], i, k, x, hit = null, at = -1;
    for (i = 0; i < src.length && !hit; i++) {
      x = P.abid ? src[i][P.abid] : null;
      if (x && x.deal === P.deal && (!P.v || !x.v || x.v === P.v)) { hit = x; at = i; break; }
      if (P.v) for (k in src[i]) { x = src[i][k]; if (x && x.deal === P.deal && x.v === P.v && (x.abid || '') === (P.abid || '')) { hit = x; at = i; break; } }
      /* 21/10 R5 FIX K2: the line's Kaching version is not live any more but its A/B arm is (Kaching keeps the arm ids when the test is
         edited: d81b66b1 -> e8803e33 on 21/10): that arm's LIVE settings (this page's, or read from the product page; never a saved
         copy or the snapshot). Was (R4): no deal = + / - disabled and no upgrade card on every cart older than the last Kaching edit */
      x = i === 0 && !hit && P.abid ? kMem[P.abid] : null;
      if (x && x.deal === P.deal) { hit = x; at = 0; break; }
    }
    if (!hit && !P.v && !P.abid) for (i = 0; i < 2 && !hit; i++) for (k in src[i]) { x = src[i][k]; if (x && x.deal === P.deal) { hit = x; at = i; break; } }   /* a line with no version (very old): this page's / the harvested deal */
    if (!hit || (at > 0 && !(Date.now() - (hit.t || 0) < 6e5))) kNeed();
    return hit;
  }
  /* the product page's live Kaching settings, read once on a page that has none (home, collection...): same fetch and parse as the
     empty card's (qaWarm). The drawer redraws when they are in (idle only: a change, an add or a queued tap draws its own view). */
  var kF = null;
  function kNeed() {
    if (kF) return kF;
    for (var k in kMem) return Promise.resolve();   /* this page already holds the live settings (product page, or read) */
    kF = origFetch(qaUrl(), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (h) {
      var f = kParse(new DOMParser().parseFromString(h, 'text/html')), n = 0, j;
      for (j in f) { kMem[j] = f[j]; n++; }
      if (n) try { localStorage.setItem(KKEY, JSON.stringify(assign(kStore(), f))); } catch (e) { }
      if (isOpen && !busy && !opt && !loading && !swapRun && !tapQ && !undoQ && !paLive()) render(keptM || model(cart));
    }).catch(function () { setTimeout(function () { kF = null; }, 15000); });
    return kF;
  }
  /* 20/10 R4 FIX K1: a Kaching jar line is resized only to a size its own deal has (known here). Was: + on a 1-bar line built a
     bundle on a bar that deal does not have, or jumped to the product page */
  function canQ(g, n) { if (!g || !g.kaching || !g.jar || g.opt || g.pa || g.wb) return true; var dl = kDeal(g.P); return !!(dl && barFor(dl, n)); }
  /* 20/10 FINAL FIX L1 (owner 20/10: "supprime le code de l'offre B", it must never come back): NO generic "one deal bar = offer B"
     detection any more. A Kaching variant with a single bar is an A variant like any other (drawn and resized as A). The B layout
     (1 jar, all 3 gifts, no stepper, no upgrade card) and the B cart guard are kept ONLY for carts that still hold a line of the old
     offer B/C/D arms (18-19/10, B cut 19/10 15:57 NY), recognised by their exact Kaching version id + A/B arm id (an arm id alone is
     not enough: caaa9a21 and e2102522 were 3-bar arms in versions 59f97380 / f87f19d0). Each of these arms sold ONE bar: 1 jar. */
  var LEGACY_B = {
    'd7f8fd9d-2638-4c54-969e-3b33b92fe5fd': ['caaa9a21-7c72-4a13-ac22-5acb3c36b19c', 'e2102522-5abd-4bfb-87da-a1344f4eb3a0'],
    '5ee8ffae-1a18-47f8-bb1c-200a38433525': ['e14f6138-9c2b-47ea-8d44-532e40840097', '14dfe5ce-fade-4703-b161-0fe1cd863fe9'],
    'f77f3b67-916d-4397-a34e-3a42f4a22b10': ['fd8c6e9f-37f3-4282-86d8-20f8a99a2576', 'ca5f61cb-c2e0-48b8-b3db-bf517125aa72', 'bcda5081-ca97-42c8-bc62-4cdef1f20e52'],
    '8c51a6e0-4913-49f8-9c3e-0af777354c8a': ['fd8c6e9f-37f3-4282-86d8-20f8a99a2576']
  };
  function isB1(P) { return !!(P && P.v && P.abid && Object.prototype.hasOwnProperty.call(LEGACY_B, P.v) && LEGACY_B[P.v].indexOf(P.abid) > -1); }
  function cartB(c) { return !!(c && c.items && c.items.some(function (it) { var P = kp(it); return P && P.main && isB1(P); })); }
  /* 20/10 FINAL FIX L1: the A bundle leads the cart (progress bar, upgrade card): an old offer B jar next to it keeps its own line look
     only (A/A review: an old B jar + an A bundle drew the whole cart as B: "All 3 gifts", no upgrade card for the A bundle) */
  /* 20/10 FINAL FIX N2: the guide lines of a removed bundle (tagged with its id) leave the instant view with it (R1 FIX N1 draws one
     guide row per guide line: after a trash on 1 of 2 bundles the view showed 2 guide rows for 1 bundle until the cart read) */
  function gOff(lines, g) { var ids = {}; (g.lines || []).forEach(function (it) { var P = kp(it); if (P && P.id) ids[P.id] = 1; }); if (g.P && g.P.id) ids[g.P.id] = 1; return (lines || []).filter(function (it) { var P = kp(it); return !(P && P.id && ids[P.id]); }); }
  function primOf(groups) { var a = null, j = null; groups.forEach(function (x) { if (x.jar && !j) j = x; if (x.jar && !x.wb && !a) a = x; }); return a || j || groups[0] || null; }
  /* 18/10 empty cart: the Kaching deals of the latest harvest only (an entry harvested more than 5 min before the newest one
     is stale: a deal or arm removed in Kaching never comes back from localStorage). */
  /* 20/10 FINAL FIX E2 (A/A review: the cut B arm flashed 0.75 s on the home page card and its Add sent "Buy 1 only"): saved data
     (localStorage whc_kdeals) counts only when harvested < 10 min ago, and not at all once this page has read the live product page's
     own Kaching settings (the product page itself, or the card's fetch of it): then only those. Nothing fresh = the neutral card (no
     price) until the fetch is in (qaWarm). The snippet's CFG.kaching snapshot (no date) is never used for the card. */
  function kFresh(pid) {
    var all = assign({}, kStore(), kMem), list = [], top = 0, now = Date.now(), live = false, k, x;
    for (k in kMem) if (kMem[k] && (!pid || !kMem[k].pid || kMem[k].pid === pid)) live = true;
    for (k in all) { x = all[k]; if (x && x.bars && x.bars.length && (!pid || !x.pid || x.pid === pid) && live && kMem[k] === x) { list.push(x); top = Math.max(top, x.t || 0); } }   /* 20/10 R4 FIX E3 (owner decision 2, strict): only what this page read on the LIVE product page; saved data alone = the neutral card until qaWarm's fetch is in (was: saved data < 10 min old, a cut arm included) */
    return list.filter(function (x) { return (x.t || 0) >= top - 3e5; });
  }
  /* the visitor's own A/B arm for the empty-cart card (every arm). On the product page: the arm Kaching shows. Elsewhere: Kaching's
     rule (kaching_session_id -> bucket -> arm range). null when the visitor has no arm yet. 20/10 FINAL FIX E2: sessionStorage
     key of the removed offer B gate's correction is ignored (A/A review: a leftover "B" gave a card with no price). */
  function abMine(pid) {
    var id = null, list = kFresh(pid), best = null, el, b, i;
    el = d.querySelector('.kaching-bundles__block[data-ab-test-variant-id]');
    if (el) for (i = 0; i < list.length; i++) if (list[i].abid && list[i].abid === el.getAttribute('data-ab-test-variant-id')) return list[i];
    try { id = localStorage.getItem('kaching_session_id'); } catch (e) { }
    if (!id) try { id = sessionStorage.getItem('kaching_session_id'); } catch (e) { }
    if (!id) return null;
    b = Math.floor(parseInt(String(id).replace(/-/g, '').slice(0, 4), 16) % 256 * 100 / 256);
    if (isNaN(b)) return null;
    list.forEach(function (x) { if (x.abid && x.rg && b >= x.rg[0] && b < x.rg[1] && (!best || (x.t || 0) > (best.t || 0))) best = x; });
    return best;
  }
  function barFor(dl, n) { if (!dl) return null; for (var i = 0; i < dl.bars.length; i++) if (dl.bars[i].n === n) return dl.bars[i]; return null; }
  /* price of a bar in cents, like Kaching: bar price, free part, then the plan discount of the paid line */
  function barPrice(bar, unit, P) {
    if (!bar) return null;
    var p;
    if (bar.dt === 'specific') p = Math.round(bar.dv * 100);
    else if (bar.dt === 'percentage') p = Math.round(unit * bar.buy * (1 - bar.dv / 100));
    else if (!bar.dt) p = unit * bar.buy;
    else return null;
    if (bar.get) {
      if (bar.gdt === 'percentage') p += Math.round(unit * bar.get * (1 - (bar.gdv || 0) / 100));
      else return null;
    }
    var adj = P && P.sellingPlan && P.sellingPlan.priceAdjustment;
    if (adj) { if (adj.type === 'percentage') p = Math.round(p * (1 - adj.value / 100)); else if (!(adj.type === 'fixed_amount' && !+adj.value)) return null; }   /* 20/10 FIX P2: {fixed_amount, 0} = no change (the + / - view showed the old price) */
    return p;
  }

  /* ---- model: Shopify cart -> preview state ---- */
  function model(c) {
    var m = { groups: [], count: 0, total: c ? c.total_price : 0, was: 0, save: 0, sub: false, q: 0, primary: null, giftLines: [] };
    if (!c || !c.items) return m;
    var by = {};
    c.items.forEach(function (it) {
      if (isHidden(it.handle)) {
        if (isGift(it.handle)) m.giftLines.push(it); else m.was += it.original_line_price;
        return;
      }
      var P = kp(it), key = P && P.id ? 'k:' + P.id + ':' + it.product_id : 'l:' + it.key;
      var g = by[key];
      if (!g) {
        var nm = (CFG.names || {})[it.handle], t = String(it.product_title || '').split(' | ');
        g = by[key] = { key: key, lines: [], handle: it.handle, url: it.url, image: it.image, variant: it.variant_id, jars: 0, final: 0, was: 0, sub: false, main: null, P: null, deal: '',
          name: nm ? nm[0] : t[0], sub2: nm ? nm[1] : (t[1] || ''), jar: (CFG.jarHandles || []).indexOf(it.handle) > -1, kaching: !!P };
        m.groups.push(g);
      }
      g.lines.push(it);
      g.jars += it.quantity; g.final += it.final_line_price; g.was += unitWas(it) * it.quantity;
      if (spOf(it)) g.sub = true;
      if (P && P.main && !P.bxgy) { g.main = it; g.P = P; }
      var da = it.line_level_discount_allocations;
      if (!g.deal && da && da.length && da[0].discount_application) g.deal = da[0].discount_application.title || '';
    });
    m.groups.forEach(function (g) {
      if (g.kaching && !g.main) { g.main = g.lines[0]; g.P = kp(g.lines[0]); }
      m.count += g.jars; m.was += g.was;
      if (!m.primary && g.jar) m.primary = g;
    });
    if (!m.primary && m.groups.length) m.primary = m.groups[0];
    if (m.primary) { m.q = Math.min(3, m.primary.jars); m.sub = !!(m.primary.jar && (m.primary.sub || m.giftLines.length || document.documentElement.classList.contains('wh1-nosub'))); } /* 27-09: gifts shown without subscription too */
    /* OFFER B (18/10): a bundle of the 1-bar Kaching variant = 1 jar with all 3 gifts unlocked, no upgrade card, no stepper */
    m.groups.forEach(function (g) { if (g.kaching && isB1(g.P)) g.wb = true; });   /* 20/10 FINAL FIX L1: old offer B/C/D lines only (LEGACY_B) */
    var pm = primOf(m.groups);   /* 20/10 FINAL FIX L1: an A bundle leads a cart that also holds an old B jar */
    if (pm && pm !== m.primary) { m.primary = pm; m.q = Math.min(3, pm.jars); m.sub = !!(pm.jar && (pm.sub || m.giftLines.length || document.documentElement.classList.contains('wh1-nosub'))); }
    if (m.primary && m.primary.wb) { m.q = 3; m.wb = true; }
    m.save = Math.max(0, m.was - m.total);
    return m;
  }
  function tierOf(g) { return TIERS[Math.min(3, Math.max(1, g.jars)) - 1]; }
  /* 23/10 B/C LABELS (owner 23/10: coordinate the B and C offers). The line label of a bundle of Kaching A/B arm B or C = its bar's
     name (B: 1 / 2 / 3 Jars, never "Get 1 FREE"; C: 30-Day / 90-Day Supply + its jars), keyed by the arm id (full, or its first 8
     characters) + the bar id of the line's __kaching_bundles (bar, else bid: a drawer resize writes bar and keeps the old bid). A line
     whose jars are not its bar's (a + / - being saved) and the product page's instant / pending line (no properties yet: the arm of
     this page's Kaching block) take the arm's bar of that size; none = no label. The jar count is in the label: the stepper shows the
     number only. Arm A (de7c1157) and every other arm / line: null = unchanged. */
  var BCL = { e409c0e8: { fjJ0: [1, '1 Jar'], EE94: [2, '2 Jars'], vxFC: [3, '3 Jars'] }, '96aa94c7': { EE94: [1, '30-Day Supply · 1 jar'], vxFC: [3, '90-Day Supply · 3 jars'] } };
  var BCL_ID = { 'e409c0e8-c892-4ba7-87c6-17faa03de743': 'e409c0e8', e409c0e8: 'e409c0e8', '96aa94c7-ee3c-48ae-8c7e-6d554501d2b3': '96aa94c7', '96aa94c7': '96aa94c7' };
  function bcLabel(g) {
    if (!g || !g.jar || !g.kaching) return null;
    var P = g.P, a = P ? P.abid : null, own = Object.prototype.hasOwnProperty, el, T, b, k;
    if (!P && g.opt) { el = d.querySelector('.kaching-bundles__block[data-ab-test-variant-id]'); a = el && el.getAttribute('data-ab-test-variant-id'); }
    T = a && own.call(BCL_ID, a) ? BCL[BCL_ID[a]] : null;
    if (!T) return null;
    k = P ? P.bar || P.bid : null; b = k && own.call(T, k) ? T[k] : null;
    if (!b || b[0] !== g.jars) { b = null; for (k in T) if (own.call(T, k) && T[k][0] === g.jars) b = T[k]; }
    return b ? b[1] : '';
  }
  /* 23/10 B/C OFFERS F1-F3 (owner 23/10: coordinate the B and C offers; the drawer lists exactly what the cart / checkout holds and
     never calls FREE what is not). bcArm(g) = the arm (B e409c0e8 / C 96aa94c7) of a bundle line, same rule as bcLabel; null for arm A
     and every other line. A cart (or view) with a B / C bundle: no upgrade card and no gifts progress box (arm A's ladder: "Get your
     2nd jar FREE", "Buy 2, Get 1 FREE", Mystery Gift: not these offers), gift rows = US Shipping (free on every US order) + the guide
     only when the cart holds a guide line, never the Mystery Gift; guide rows = the cart's guide lines (C's 30-Day bar brings the
     guide at 1 jar). A drawer resize writes the selling plan of the new bar. Arm A: unchanged. */
  function bcArm(g) {
    if (!g || !g.jar || !g.kaching) return null;
    var a = g.P ? g.P.abid : null, el;
    if (!g.P && g.opt) { el = d.querySelector('.kaching-bundles__block[data-ab-test-variant-id]'); a = el && el.getAttribute('data-ab-test-variant-id'); }
    return a && Object.prototype.hasOwnProperty.call(BCL_ID, a) ? BCL_ID[a] : null;
  }
  function bcView(m) { return !!(m && m.groups && m.groups.some(function (g) { return !!bcArm(g); })); }
  /* the Kaching bar of a B / C line's size: its own deal (kDeal); the instant / pending line of a page add: this page's arm */
  function bcBarOf(g) {
    var dl = null, el, a;
    if (g.P) dl = kDeal(g.P);
    else if (g.opt) { el = d.querySelector('.kaching-bundles__block[data-ab-test-variant-id]'); a = el && el.getAttribute('data-ab-test-variant-id'); dl = a ? kMem[a] || kStore()[a] || null : null; }
    return barFor(dl, g.jars);
  }
  /* guide rows of a view with a B / C bundle: one per guide line of the cart; a line shown at a size not saved yet (a + / - being
     saved, the instant / pending line of a page add): the gifts of its bar of that size (B / C: its Kaching bar; A: from 2 jars) in
     place of the guide lines of its old size */
  function bcGuideN(m) {
    var n = 0, skip = {};
    (m.groups || []).forEach(function (g) {
      var q = 0, b;
      (g.lines || []).forEach(function (it) { q += it.quantity; });
      if (!g.opt && q === g.jars) return;
      if (g.P && g.P.id) skip[g.P.id] = 1;
      if (bcArm(g)) { b = bcBarOf(g); n += b ? b.gifts.length : 0; }
      else if (g.kaching && g.jar && g.jars >= GIFTS[1].need) n++;
    });
    (m.giftLines || []).forEach(function (it) { var P = kp(it); if (!(P && P.id && skip[P.id])) n++; });
    return n;
  }
  /* F3: selling plan of a resized bundle = its new bar's (Kaching deal data). A deal copy saved before 23/10 has no plan per bar:
     the 23/10 B / C plans (arm + bar, like the labels), only when the line's own plan is its bar's 23/10 plan. 0 = keep the line's */
  var BCP = { e409c0e8: { fjJ0: 8429076724, EE94: 8429109492, vxFC: 8429142260 }, '96aa94c7': { EE94: 8429076724, vxFC: 8429142260 } };
  function bcPlan(g, bar, sp) {
    if (!bar || !sp) return 0;
    if (bar.sp > 0) return bar.sp;
    var a = bcArm(g), T = a ? BCP[a] : null, own = Object.prototype.hasOwnProperty, k = g.P ? g.P.bar || g.P.bid : null;
    return T && own.call(T, bar.id) && k && own.call(T, k) && T[k] === sp ? T[bar.id] : 0;
  }
  /* 24/10 OFFER TEST D (gifts model, snippets/wh-ox-offer.liquid): a bundle whose Kaching deal has a 2-jar quantity-break bar and a
     selling plan on every bar = no free jar: "Buy 2 + 1 FREE gift" / "Buy 3 + 2 FREE gifts", never "Get 1 FREE". A line with no
     Kaching properties yet (instant view of a page add): the page's arm (html.wh-ox-g). Every other deal / arm A: false = unchanged. */
  function oxG(g) {
    if (!g || !g.jar || !g.kaching) return false;
    var dl = g.P ? kDeal(g.P) : null, b2 = dl && barFor(dl, 2);
    if (dl) return !!(b2 && !b2.get && dl.bars.length === 3 && dl.bars.every(function (b) { return b.sp > 0; }));
    return !g.P && d.documentElement.classList.contains('wh-ox-g');
  }
  var OXT = ['', 'Buy 2 + 1 FREE gift', 'Buy 3 + 2 FREE gifts'];
  function dealText(g) {
    var bl = bcLabel(g); if (bl != null) return bl;   /* 23/10 B/C LABELS */
    if (g.jar && g.kaching && g.jars <= 3) return oxG(g) ? OXT[Math.max(1, g.jars) - 1] : tierOf(g).deal;   /* 24/10 offer test D */
    if (/only$/i.test(g.deal)) return '';
    return g.deal;
  }
  function maxQ(g) { return g.jar ? 3 : 99; }
  /* next bundle for the upgrade card: {n, price, diff, jars} or null */
  /* 27-09: real tier prices [autoship, one-time] in cents as rendered by Kaching on the product page (WH1P.T), remembered for other pages */
  function realTiers() {
    try {
      var P = window.WH1P, st = P && P.state && P.state();
      if (P && P.T && st && st.ready) { localStorage.setItem('wh1T', JSON.stringify(P.T)); return P.T; }
      var s = localStorage.getItem('wh1T'); return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }
  function nextTier(g) {
    if (g && g.wb) return null;   /* OFFER B: no upgrade (never the stale CFG.kaching / WH1P.T tiers) */
    if (g && g.opt) return g.nx;   /* optimistic line: next bundle from the offer prices (WH1P.T) */
    if (!g || !g.jar || !g.kaching || g.jars >= 3) return null;
    var n = g.jars + 1, bar = barFor(kDeal(g.P), n);
    if (!bar) return null;
    var price = barPrice(bar, unitWas(g.main), g.P);
    var RT = realTiers(); if (RT && RT[n - 1]) price = g.sub ? RT[n - 1][0] : RT[n - 1][1];   /* 27-09: real Kaching prices from the offer, not the stale bar formula */
    if (price == null) return null;
    return { n: n, jars: n, price: price, diff: price - g.final };
  }
  function unlocked(m) {
    if (bcView(m)) { var bn = bcGuideN(m); return m.sub ? GIFTS.filter(function (g) { return g === GIFTS[0] || (g === GIFTS[1] && bn > 0); }) : []; }   /* 23/10 B/C F1 */
    return m && m.sub ? GIFTS.filter(function (g) { return m.q >= g.need; }) : [];
  }
  function fresh(prev, m) {
    var had = unlocked(prev).map(function (g) { return g.need; });
    return unlocked(m).filter(function (g) { return had.indexOf(g.need) < 0; }).map(function (g) { return g.need; });
  }
  function shipText() {
    try {
      var n = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
      var cut = new Date(n); cut.setHours(14, 0, 0, 0);
      var fmt = function (x) { return x.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' }); };
      if (n.getDay() > 0 && n.getDay() < 6 && n < cut) {
        var ms = cut - n, h = Math.floor(ms / 36e5), mi = Math.floor(ms % 36e5 / 6e4);
        return 'Order within <b>' + (h ? h + 'h ' : '') + mi + 'm</b> and it ships <b>today</b>';
      }
      var s = new Date(n);
      do { s.setDate(s.getDate() + 1); } while (s.getDay() === 0 || s.getDay() === 6);
      return 'Order now and it ships <b>' + fmt(s) + '</b>';
    } catch (e) { return 'Order today and it ships in <b>1 business day</b>'; }
  }
  function onPdp() { return !!d.querySelector('.qty--of8'); }

  /* ---- hold timer (10:00 from the first open with a full cart, per tab) ---- */
  var holdMem = 0;
  function holdEnd(start) {
    var t = 0;
    try { t = +sessionStorage.getItem(HOLD) || 0; } catch (e) { t = holdMem; }
    if (!t) t = holdMem;
    if (!t && start) {
      t = Date.now() + HOLD_MS; holdMem = t;
      try { sessionStorage.setItem(HOLD, String(t)); } catch (e) { }
    }
    return t;
  }
  function holdRestartIfOver() {
    var t = holdEnd(false);
    if (!t || t > Date.now()) return;
    holdMem = 0;
    try { sessionStorage.removeItem(HOLD); } catch (e) { }
    if (E.tmt) { E.tmt.removeAttribute('data-done'); E.tmt.textContent = ''; }
  }

  /* ---- DOM ---- */
  var root, panel, E = {}, isOpen = false, back = null, timer = 0, lastFill = null, removed = null, saved = null, shipAt = 0, loading = false, lastM = null, changed = false;
  var opt = null;                    /* instant cart: the optimistic add in flight (see INSTANT CART) */
  var undoQ = false, qaShield = 0, afRd = 0, coI = 0, coT = 0, addT0 = 0, atcTap = null, addDrawT = 0;   /* 20/10 FIX U1/U2/C1/R1 (see below) */
  /* 19/10 FIX B5 (review: drawer redrawn EMPTY while the jar is in the cart). The add went through (Shopify said OK) but /cart.js could
     not be read: settle() keeps that line on screen, while the cached cart is still the one from before the add. keptM = that line,
     the last known cart: open(), a failed refresh / afterAdd read, openLoading() and the add-error view draw it instead of the stale
     cache; the first real cart read (setCart, or a read during an add) clears it. Set only after an add Shopify accepted. */
  var keptM = null;
  var scrolled = false, closedAt = 0;
  var ERR_ADD = 'Sorry, that did not go through. Please try again.';
  function build() {
    if (root) return;
    root = d.getElementById('whc');
    if (!root) { root = d.createElement('div'); root.id = 'whc'; d.body.appendChild(root); }
    root.className = 'whc';
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');
    root.innerHTML =
      '<div class="whc__bk" data-whc-close></div>' +
      '<div class="whc__p" role="dialog" aria-modal="true" aria-labelledby="whc-h" tabindex="-1">' +
        '<div class="whc__hd"><h2 class="whc__h" id="whc-h">Your cart <span class="whc__n" hidden></span></h2>' +
        '<button type="button" class="whc__x" data-whc-close aria-label="Close cart">' + IC.close + '</button></div>' +
        '<div class="whc__tm" role="timer" hidden>' + IC.clock + '<span class="whc__tmt"></span></div>' +
        '<div class="whc__err" role="alert" hidden></div>' +
        '<div class="whc__sc"></div>' +
        '<div class="whc__ft" hidden></div>' +
        '<div class="whc__toast" role="status" aria-live="polite"></div>' +
        '<p class="whc__sr" aria-live="polite"></p>' +
      '</div>';
    panel = root.querySelector('.whc__p');
    E.n = root.querySelector('.whc__n'); E.x = root.querySelector('.whc__x');
    E.tm = root.querySelector('.whc__tm'); E.tmt = root.querySelector('.whc__tmt');
    E.err = root.querySelector('.whc__err');
    E.sc = root.querySelector('.whc__sc'); E.ft = root.querySelector('.whc__ft');
    E.toast = root.querySelector('.whc__toast'); E.sr = root.querySelector('.whc__sr');
    E.n.appendChild(d.createTextNode('')); E.sr.appendChild(d.createTextNode('')); E.err.appendChild(d.createTextNode(''));
    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    E.sc.addEventListener('scroll', function () { scrolled = true; }, { passive: true });
  }
  function showErr(msg) { if (!E.err) return; setText(E.err, msg); E.err.hidden = false; }
  function hideErr() { if (E.err && !E.err.hidden) E.err.hidden = true; }

  function jarsHTML(n, sm) {
    var h = '<span class="whc__jr n' + n + (sm ? ' sm' : '') + '" aria-hidden="true">';
    for (var i = 0; i < n; i++) h += '<img src="' + IMG.jar + '" alt="" width="142" height="270">';
    return h + '</span>';
  }
  function progressHTML(m, at) {
    var q = m.q, msg;
    if (q === 1) msg = oxG(m.primary) ? '<b>1 FREE gift unlocked.</b> Add a 2nd jar to unlock the <em>$29 Guide</em>.' : '<b>1 FREE gift unlocked.</b> Get your 2nd jar FREE to unlock the <em>$29 Guide</em>.';   /* 24/10 offer test D: no free jar */
    else if (q === 2) msg = '<b>2 FREE gifts unlocked.</b> Add 1 more jar to unlock the <em>Mystery Gift</em>.';
    else msg = '<b>All 3 FREE gifts unlocked.</b> You got the best deal.';
    var steps = GIFTS.map(function (g) {
      var on = q >= g.need;
      return '<li class="whc__s' + (on ? ' is-on' : '') + '"><span class="whc__sn"><img src="' + g.img + '" alt="" width="36" height="36"><i class="whc__sk">' + (on ? IC.check : IC.lock) + '</i></span>' +
        '<span class="whc__sl">' + g.step + '<span class="whc__sr">' + (on ? ', unlocked' : ', locked') + '</span></span></li>';
    }).join('');
    var from = at ? FILL[q] : lastFill === null ? FILL[q] : lastFill;
    return '<div class="whc__gp"><p class="whc__gm">' + msg + '</p>' +
      '<div class="whc__trk" role="progressbar" aria-label="Free gifts unlocked" aria-valuemin="0" aria-valuemax="3" aria-valuenow="' + q + '"><i style="width:' + from + '"></i></div>' +
      '<ol class="whc__stp">' + steps + '</ol></div>';
  }
  function lineHTML(g, i) {
    if (g.wb && !g.__wb) return lineHTML(assign({}, g, { __wb: 1 }), i).replace(/<button type="button" data-whc="(dec|inc)"[^>]*>[\s\S]*?<\/button>/g, '').replace('<div class="whc__it" data-g', '<div class="whc__it whc__itb" data-g');   /* OFFER B: no stepper; 19/10 v2: the "1 jar" count stays, in the box of A's "2 jars" */
    var n = g.jars, deal = dealText(g), name = esc(g.name), img;
    if (g.jar) img = '<img class="whc__hero" src="' + esc(heroFor(g)) + '" alt="" width="64" height="64" decoding="async">' + (n > 1 ? '<span class="whc__qb">' + n + 'x</span>' : '');   /* 19/10 v2: first gallery image */
    else img = '<span class="whc__jr n1" aria-hidden="true">' + (g.image ? '<img src="' + esc(g.image) + '" alt="" width="142" height="270">' : '') + '</span>' + (n > 1 ? '<span class="whc__qb">' + n + 'x</span>' : '');
    return '<div class="whc__it" data-g="' + i + '">' +
      '<div class="whc__im">' + img + '</div>' +
      '<div class="whc__bd">' +
        '<div class="whc__tp"><div><p class="whc__tt">' + name + '</p>' + (g.sub2 ? '<p class="whc__ts">' + esc(g.sub2) + '</p>' : '') + '</div>' +
        '<button type="button" class="whc__rm" data-whc="rm" data-g="' + i + '" aria-label="Remove ' + name + ' from your cart">' + IC.trash + '</button></div>' +
        '<div class="whc__mt">' + (deal ? '<span class="whc__dl">' + esc(deal) + '</span>' : '') + (g.jar ? '<span class="whc__dy">' + n * 15 + '-day supply</span>' : '') + '</div>' +
        '<div class="whc__bt"><div class="whc__q" role="group" aria-label="' + (g.jar ? 'Number of jars' : 'Quantity') + '">' +
          '<button type="button" data-whc="dec" data-g="' + i + '" aria-label="' + (g.jar ? 'Fewer jars' : 'Decrease quantity') + '"' + (n <= 1 || !canQ(g, n - 1) ? ' disabled' : '') + '>' + IC.minus + '</button>' +
          '<span>' + (g.jar && !bcLabel(g) ? jarsWord(n) : n) + '</span>' +   /* 23/10 B/C LABELS: the jars are in the label */
          '<button type="button" data-whc="inc" data-g="' + i + '" aria-label="' + (g.jar ? 'More jars' : 'Increase quantity') + '"' + (n >= maxQ(g) || !canQ(g, n + 1) ? ' disabled' : '') + '>' + IC.plus + '</button></div>' +
        '<div class="whc__pr">' + (g.was > g.final ? '<s><span class="whc__sr">Regular price </span>' + money(g.was) + '</s>' : '') + '<b>' + money(g.final) + '</b>' +
          (g.was > g.final ? '<small>You save ' + money(g.was - g.final) + '</small>' : '') + '</div></div>' +
      '</div></div>';
  }
  function giftsHTML(m, fr) {
    var list = unlocked(m);
    if (!list.length) return '';
    var rows = list.map(function (g) {
      return '<li class="whc__g' + (fr && fr.indexOf(g.need) > -1 ? ' is-new' : '') + '"><img src="' + g.img + '" alt="" width="48" height="48">' +
        '<div><p class="whc__gn">' + g.name + '</p><p class="whc__gs">' + g.sub + '</p></div>' +
        '<p class="whc__gv">' + (g.value ? '<s><span class="whc__sr">Value </span>' + money(g.value) + '</s>' : '') + '<b>FREE</b></p></li>';
    }).join('');
    return '<div class="whc__gb"><span class="whc__gbt">' + IC.gift + (list.length === 1 ? '1 gift' : list.length + ' gifts') + ' unlocked</span><ul class="whc__gl">' + rows + '</ul></div>';
  }
  /* 18/10 guide line (Adrien: "met le dans le panier", "comme un produit", "barre le $29"): the free guide is a real cart line
     (Kaching gift child line and/or ensureGifts) whose handle stays hidden like every gift (badge, totals, model unchanged). Shown here
     as ONE product-like line under the jar line(s): thumbnail box, name, "Free ebook", struck $29 + FREE (the only struck price in the
     drawer: owner's explicit exception to the 27/09 rule). No stepper, no remove. Shown when the drawer says the Guide is unlocked
     (same rule as the progress bar) AND the cart holds the guide line; the optimistic view predicts it so nothing jumps. */
  function guideHTML(m) {
    var gf = GIFTS[1], bc = bcView(m);   /* 23/10 B/C F2: a cart with a B / C bundle: its guide lines (bcGuideN) */
    if (bc && !bcGuideN(m)) return '';
    if (!bc && (!m || !m.sub || (m.q < gf.need && !m.groups.some(function (g) { return g.wb; })))) return '';   /* 20/10 FINAL FIX L1: an old B jar brings its guide */
    if (!bc && !(m.giftLines || []).length && !m.groups.some(function (g) { return g.opt; })) return '';
    var was = money(gf.value).replace(/\.00$/, '');
    return '<div class="whc__it whc__gd" style="grid-template-columns:48px minmax(0,1fr) auto;gap:12px;padding:10px 14px;align-items:center">' +
      '<div class="whc__im" style="width:48px;height:48px;display:grid;place-items:center;overflow:hidden"><img src="' + esc(gf.img || '') + '" alt="" width="30" height="44" loading="lazy" decoding="async" style="width:30px;height:44px;object-fit:contain;filter:drop-shadow(0 3px 4px rgba(0,0,0,.5))"></div>' +
      '<div style="min-width:0"><p class="whc__tt" style="font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + esc(gf.name) + '</p>' +
        '<p style="font:500 11.5px/1.3 var(--w-sans);color:var(--w-dim);margin-top:3px">Free ebook</p></div>' +
      '<p style="display:flex;flex-direction:column;align-items:flex-end;gap:2px;margin:0;text-align:right">' +
        '<s style="display:inline!important;font:500 12px/1 var(--w-sans);color:var(--w-dim)"><span class="whc__sr">Value </span>' + was + '</s>' +
        '<b style="font:700 14px/1 var(--w-sans);color:var(--w-green);letter-spacing:.04em">FREE</b></p></div>';
  }
  function upgradeHTML(m) {
    return ; /* 23/10 owner: "enleve l upsell panier" - cart upsell card removed for every arm */
    var g = m.primary, nx = nextTier(g);
    if (!nx) return '';
    var diff = nx.diff, kick, title, desc, btn;
    if (nx.n === 2) {
      kick = '2nd jar FREE';
      title = 'Get your 2nd jar <span>FREE</span>';
      desc = '2 jars for <b>' + money(nx.price) + '</b>' + (diff <= 0 ? ', even less than 1 jar (' + money(g.final) + ')' : ', just ' + money(diff) + ' more') +
        (m.sub ? '. Unlocks the FREE $29 Guide.' : '.');
      btn = 'Yes, add my FREE jar';
    } else {
      kick = 'Best value';
      title = 'Upgrade to <span>Buy 2, Get 1 FREE</span>';
      desc = 'Add a 3rd jar for just <b>' + money(diff) + '</b> (' + money(Math.round(nx.price / nx.jars)) + ' per jar)' + (m.sub ? ' and unlock the FREE Mystery Gift.' : '.');
      btn = 'Add my 3rd jar · +' + money(diff);
    }
    return '<div class="whc__up"><span class="whc__upk">' + kick + '</span><div class="whc__upi">' + jarsHTML(nx.jars, true) + '</div>' +
      '<div><p class="whc__upt">' + title + '</p><p class="whc__upd">' + desc + '</p></div>' +
      '<button type="button" class="whc__upb" data-whc="up">' + IC.plus + btn + '</button></div>';
  }
  /* MOCKUP (same as the preview): sample review of the product-page hero bubble. Replace with a real one. */
  function reviewHTML() {
    return '<div class="whc__rv"><img src="' + IMG.avatar + '" alt="" width="40" height="40">' +
      '<div><p class="whc__rvs" aria-label="Rated 5 out of 5">★★★★★</p><p class="whc__rvq">“My beer belly is gone. My wife noticed first.”</p>' +
      '<p class="whc__rvn">Rick D., 58<span>✔ Verified buyer</span></p></div></div>';
  }
  function protectHTML() {
    if (!SHIP_H) return '';
    var on = !!(cart && cart.items.some(function (i) { return i.handle === SHIP_H; })) || shipWanted();
    return '<label class="whc__pt"><span class="whc__ptt"><b>' + esc(CFG.shipTitle || 'Shipping protection') + '</b> ' + money(CFG.shipPrice || 0) +
      '<small>Protected from damage, loss or theft in transit.</small></span>' +
      '<input type="checkbox" data-whc="ship"' + (on ? ' checked' : '') + '><i aria-hidden="true"></i></label>';
  }
  function footerHTML(m) {
    return protectHTML() +
      '<div class="whc__sum"><div><p class="whc__tl">Total</p>' + (m.save > 0 ? '<p class="whc__sv">You save ' + money(m.save) + '</p>' : '') +
        (m.sub ? '' : '<p class="whc__sp">Shipping at checkout</p>') + '</div>' +
      '<p class="whc__tv">' + (m.was > m.total ? '<s><span class="whc__sr">Regular price </span>' + money(m.was) + '</s>' : '') + '<b>' + money(m.total) + '</b></p></div>' +
      '<button type="button" class="whc__co" name="checkout" data-whc="co">' + IC.padlock + '<span>Secure checkout</span>' + IC.arrow + '</button>' +   /* 19/10 v2: no price on the button */
      '<p class="whc__rvl"><span class="whc__rvst" aria-hidden="true">★★★★★</span><span><b>4.8</b> · 2,137 reviews</span><span class="whc__rvd" aria-hidden="true"></span><span><b>50,000+</b> men</span></p>' +
      '<ul class="whc__tb"><li>' + IC.shield + '<span><span class="whc__nw">60-day</span> <span class="whc__nw">money-back</span> guarantee</span></li><li>' + IC.padlock + '<span>Secure<br>checkout</span></li><li>' + IC.truck + '<span>' + (m.sub ? 'Free US<br>shipping' : 'Ships in 1<br>business day') + '</span></li></ul>';
  }
  function payHTML() {
    return '<div class="whc__pm" role="list" aria-label="Accepted payment methods">' + PAY.map(function (p) { return '<img role="listitem" src="' + ((IMG.pay || {})[p[0]] || '') + '" alt="' + p[1] + '" width="34" height="22">'; }).join('') + '</div>';
  }
  /* ---- EMPTY CART QUICK ADD (07-10, Adrien): mono-product store, so the empty drawer sells the jar directly.
     Product card (offer preselected on the product page) + one-tap Add to cart, stars + review, guarantee + trust.
     Offer data: Kaching settings harvested on the product page (localStorage whc_kdeals, now with version id + preselected bar),
     refreshed from the product page HTML when older than 10 min, so a change of offer in Kaching shows up in the cart too.
     18/10 (Adrien: "mets en plus gros... le mec comprend que son panier est vide... un peu plus bas tu mets l'offre"): big
     "Your cart is empty", then the visitor's OWN offer (his A/B arm, prices from Kaching), and the add always goes through the
     product page's own Kaching offer (tagged ab/abid like a page add, see qaAdd). 19/10: card = the pre-18/10 card again,
     only the heading kept big (see emptyHTML). */
  var QA = { deal: null, vid: 0, pid: 0, busy: false, warm: null }, QKEY = 'whc_qa2';
  function qaUrl() { return String(CFG.shopUrl || '/products/wildhorn-bison').split('#')[0].split('?')[0]; }
  function qaDeal(pid) {
    var mine = abMine(pid), best = null;   /* 18/10: the visitor's own arm (A, B or C) */
    if (mine) return mine;
    /* no arm: the plain deal (no A/B test); during a test a visitor without arm gets no offer card (no price shown) */
    kFresh(pid).forEach(function (x) { if (x.v && !x.abid && (!best || (x.t || 0) > (best.t || 0))) best = x; });
    return best;
  }
  function qaBar(dl) {
    if (!dl) return null;
    var b = null; dl.bars.forEach(function (x) { if (x.id === dl.pre) b = x; });
    return b || barFor(dl, 2) || dl.bars[0] || null;
  }
  function qaWarm() {
    if (QA.warm) return QA.warm;
    var url = qaUrl(), c = null;
    try { c = JSON.parse(localStorage.getItem(QKEY)); } catch (e) { }
    var pP = c && c.vid && c.pid && Date.now() - (c.t || 0) < 864e5 ? Promise.resolve(c) : jget(url + '.js').then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
      var sg = (p.selling_plan_groups || [])[0], sp = sg && sg.selling_plans && sg.selling_plans[0];
      var o = { pid: p.id, vid: v.id, sp: sp ? sp.id : null, t: Date.now() };   /* 08/10: subscription only -> quick add sends the product's plan */
      try { localStorage.setItem(QKEY, JSON.stringify(o)); } catch (e) { }
      return o;
    });
    QA.warm = pP.then(function (o) {
      QA.pid = o.pid; QA.vid = o.vid; QA.sp = o.sp || null;
      var dl = qaDeal(o.pid);
      if (dl && Date.now() - (dl.t || 0) < 6e5) return dl;   /* offer changed in Kaching: picked up within 10 min (instantly on the product page) */
      return origFetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
        var f = kParse(new DOMParser().parseFromString(h, 'text/html')), n = 0, k;
        for (k in f) { kMem[k] = f[k]; n++; }
        if (n) try { localStorage.setItem(KKEY, JSON.stringify(assign(kStore(), f))); } catch (e) { }
        return qaDeal(o.pid) || dl;
      });
    }).then(function (dl) {
      QA.deal = dl || null;
      if (isOpen && !busy && !opt && !loading && !keptM && cart && !model(cart).groups.length) render(model(cart));   /* 19/10 FIX B5: not over a kept line */
      return QA.deal;
    }).catch(function () { QA.warm = null; return null; });
    return QA.warm;
  }
  /* 18/10: the add goes through the product page's own Kaching offer, so the cart lines carry the A/B tags (ab, abid) and the
     plan exactly like a page add: select the card's bar on the page + #atc (wh1-product.js), which submits Kaching's form and
     opens this drawer on the new line (20/10 FINAL: no offer B/C button any more).
     Other pages (no Kaching there): the button opens the product page, which adds the same offer on load (qaResume, same
     path, only if the cart is still empty). Never a raw /cart/add from the drawer. Visitor without arm: product page only. */
  var QADD = 'whc_qadd';
  function onPdp() { var h = pageHandle(); return !!h && qaUrl().split('/').pop() === h && !!d.getElementById('atc'); }   /* 20/10 FINAL FIX L1: no offer B button any more */
  function pdpAdd(btn, n, wait) {
    var t0 = Date.now(), h = d.documentElement;
    var done = function () { QA.busy = false; if (btn) btn.disabled = false; };
    QA.busy = true; if (btn) btn.disabled = true;
    /* Kaching not ready in time: the drawer closes on the page offer */
    var miss = function () { done(); if (btn) { close(); var o = d.getElementById('offer'); if (o) o.scrollIntoView({ behavior: 'smooth', block: 'start' }); } };
    (function go() {
      var P = W.WH1P, st = null, a = d.getElementById('atc');
      try { st = P && P.state ? P.state() : null; } catch (e) { }   /* 20/10 FINAL FIX L1: the A offer only (the offer B/C block branch is gone) */
      if (h.classList.contains('wh1-kcnative')) { miss(); return; }   /* 20/10 R4 FIX B2: Kaching's own block is on the page (1-2 bar variant, wh1-product.js): the visitor picks there */
      if (st && st.ready && a) {
        var qb = n ? d.querySelector('.qty--of8 button[data-q="' + n + '"]') : null, ins = d.querySelectorAll('.plan input');
        if (qb && st.q !== n) qb.click();
        if (!st.autoship && ins[0]) { ins[0].checked = true; ins[0].dispatchEvent(new Event('change', { bubbles: true })); }   /* the card sells the subscription */
        setTimeout(function () { a.click(); setTimeout(done, 1500); }, 150);
        return;
      }
      if (Date.now() - t0 < (wait || 10000)) { setTimeout(go, 200); return; }
      miss();
    })();
  }
  function qaAdd(btn) {
    if (QA.busy) return;
    var b = qaBar(qaNow());
    if (onPdp()) { pdpAdd(btn, b ? b.n : 0); return; }
    if (b) try { sessionStorage.setItem(QADD, JSON.stringify({ t: Date.now(), n: b.n })); } catch (e) { }
    if (btn) { btn.disabled = true; setTimeout(function () { btn.disabled = false; }, 4000); }
    location.href = qaUrl() + '#offer';
  }
  /* back/forward cache: the page left by a tap here comes back as it was, button disabled: re-enable it */
  addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    QA.busy = false;
    [].forEach.call(d.querySelectorAll('#whc [data-whc="qa"]'), function (x) { x.disabled = false; });
  });
  /* product page load after a tap on the card elsewhere (< 1 min): same add as a tap here, once (the flag is consumed first) */
  function qaResume() {
    var o = null;
    try { o = JSON.parse(sessionStorage.getItem(QADD)); if (o) sessionStorage.removeItem(QADD); } catch (e) { }
    if (!o || !(Date.now() - (o.t || 0) < 6e4) || !onPdp()) return;
    fetchCart().then(function (c) { if (!model(c).groups.length) pdpAdd(null, o.n, 20000); }).catch(function () { });
  }
  function qaNow() { var c = null; try { c = JSON.parse(localStorage.getItem(QKEY)); } catch (e) { } return qaDeal(QA.pid || (c && c.pid) || 0) || QA.deal; }
  /* 19/10 (Adrien: "laisse comme c'etait... juste le titre plus gros"): the empty card is the pre-18/10 card again, only the
     "Your cart is empty" heading bigger (26px). Deal = qaNow(), the same deal as the add (qaAdd: the visitor's own arm). */
  function emptyHTML() {
    var dl = qaNow();
    var b1 = qaBar(dl);
    if (b1 && b1.n === 1 && !emptyHTML.__b) { emptyHTML.__b = 1; try { return emptyHTML().replace(' jars · ', ' jar · ').replace(/<span>[^<]*per jar<\/span>/, ''); } finally { emptyHTML.__b = 0; } }   /* a 1-jar bar: "1 jar", no per-jar price (20/10 FINAL FIX L1: any variant, no B layout) */
    if (!QA.warm) setTimeout(qaWarm, 0);
    var b = qaBar(dl), p = b ? barPrice(b, 0, null) : null, n = b ? b.n : 2;
    var deal = b && b.get ? 'Buy ' + b.buy + ', Get ' + b.get + ' FREE' : 'Limited time deal';
    return '<div class="whc__em whc__qe"><p class="whc__emh" style="font-size:26px;line-height:1.1">Your cart is empty</p>' +
      '<div class="whc__qa"><span class="whc__qak">' + IC.gift + esc(deal) + '</span>' +
        '<div class="whc__qar"><img src="' + esc(IMG.jar || '') + '" alt="Wild Bison Organs" width="76" height="76">' +
          '<div><p class="whc__qan">Wild Bison Organs</p><p class="whc__qad">' + n + ' jars · ' + (n * 15) + '-day supply' + (b && b.gifts.length ? ' + FREE bonus guide' : '') + '</p>' +
          (p ? '<p class="whc__qap"><b>' + money(p) + '</b><span>' + money(Math.round(p / n)) + ' per jar</span></p>' : '') + (QA.sp ? '<p class="whc__qsb">' + IC.check + 'Subscription · Refills every 28 days · Cancel anytime</p>' : '') + '</div></div>' +
        '<button type="button" class="whc__qab" data-whc="qa">' + IC.plus + '<span>Add to cart' + (p ? ' · ' + money(p) : '') + '</span></button></div>' +
      '<div class="whc__qs"><span class="whc__qst" aria-hidden="true">★★★★★</span><span><b>4.8</b>/5 from <b>2,137</b> reviews</span></div>' +
      '<div class="whc__qrv"><img src="' + esc(IMG.avatar || '') + '" alt="" width="40" height="40"><div><p class="whc__qrq">“My beer belly is gone. My wife noticed first.”</p>' +
        '<p class="whc__qrn">Rick D., 58<span>' + IC.check + 'Verified buyer</span></p></div></div>' +
      '<div class="whc__qg">' + IC.shield + '<div><p class="whc__qgt">60-day money-back guarantee</p><p class="whc__qgd">Feel the difference or get your money back.</p></div></div>' +
      '<ul class="whc__qt"><li>' + IC.padlock + '<span>Secure checkout</span></li><li>' + IC.truck + '<span>Ships in 1 business day</span></li><li>' + IC.check + '<span>Real bison organs</span></li></ul>' +
      payHTML() +
      '<a class="whc__qlink" href="' + esc(qaUrl()) + '#offer" data-whc="shop">See all offers</a></div>';
  }
  function loadingHTML() {
    return '<div class="whc__ld" aria-hidden="true"><i class="whc__ldi"></i><span><i></i><i></i><i></i></span></div><p class="whc__sr">Updating your cart</p>';
  }

  /* render = patch (instant cart 27-09): same html as before, but unchanged blocks keep their nodes, text and
     attribute changes are applied in place, and nothing reads layout (no scrollTop read, no forced reflow).
     opts: top (scroll to top), fresh (gift rows to animate), pre (hidden pre-render of the drawer, see prewarm) */
  function render(m, opts) {
    build();
    opts = opts || {};
    m = m || model(cart);
    if (!opts.pre) m = qView(paView(m));   /* 20/10 R2 FIX A2 / T2: + the pending line of a page add, + the taps still queued */
    var n = m.count, pre = !!opts.pre;
    var ae = d.activeElement, fa = ae && ae !== root && root.contains(ae) ? ae.getAttribute('data-whc') : null;
    if (E.n.hidden !== !n) E.n.hidden = !n;
    setText(E.n, n);
    var al = n ? jarsWord(n) : ''; if (E.n.getAttribute('aria-label') !== al) E.n.setAttribute('aria-label', al);
    var empty = !m.groups.length;
    if (loading && empty) {
      root.classList.remove('is-empty'); E.tm.hidden = true; E.ft.hidden = true; setHTML(E.ft, '');
      patch(E.sc, [{ k: 'ld', h: loadingHTML() }]); pendUI(m); return;
    }
    if (root.classList.contains('is-empty') !== empty) root.classList.toggle('is-empty', empty);
    if (E.tm.hidden !== empty) E.tm.hidden = empty;
    if (E.ft.hidden !== empty) E.ft.hidden = empty;
    if (empty) { patch(E.sc, [{ k: 'em', h: emptyHTML() }]); setHTML(E.ft, ''); if (!pre) { lastFill = null; lastM = m; } pendUI(m); return; }
    /* DOM order like the preview: progress, bundle line, gifts, upgrade, ships-by, review, payment logos */
    var t19cut = !pre && !t19want && t19A && m.sub && FILL[m.q] !== lastFill ? t19cutNow() : null;   /* 19/10 v2: a render that moves the bar during the grow cuts it where it is */
    if (t19cut) lastFill = t19cut;
    var sl = [];
    var bcv = bcView(m);   /* 23/10 B/C F1 / F2 */
    if (m.sub && !bcv) sl.push({ k: 'gp', h: progressHTML(m, pre) });
    m.groups.forEach(function (g, i) { sl.push({ k: 'it' + i, h: lineHTML(g, i) }); });
    var gdh = guideHTML(m); if (gdh) for (var gn = 0, gN = bcv ? bcGuideN(m) : Math.max(1, (m.giftLines || []).length + (m.gdx || 0)); gn < gN; gn++) sl.push({ k: gn ? 'gd' + gn : 'gd', h: gdh });   /* 18/10 guide line, under the jar line(s). 20/10 R1 FIX N1: one row per guide line of the cart (2 bundles = 2 guides) */
    if (m.sub) { var gh = giftsHTML(m, pre ? null : opts.fresh); if (gh) sl.push({ k: 'gb', h: gh }); }
    if (m.primary && m.q < 3 && !bcv) { var uh = upgradeHTML(m); if (uh) sl.push({ k: 'up', h: uh }); }   /* 23/10 B/C F1: no upgrade card */
    sl.push({ k: 'sh', h: '<p class="whc__sh">' + IC.truck + '<span>' + shipText() + '</span></p>' }, { k: 'rv', h: reviewHTML() }, { k: 'pm', h: payHTML() });
    patch(E.sc, sl);
    setHTML(E.ft, footerHTML(m));
    if (opts.top && scrolled) { E.sc.scrollTop = 0; scrolled = false; }
    pendUI(m);
    if (pre) {
      /* timer row ready for the first tick (text data only at open) */
      if (!E.tmt.firstChild) E.tmt.innerHTML = 'Your cart is reserved for <b>' + Math.floor(HOLD_MS / 60000) + ':00</b>';
      return;
    }
    shipAt = Date.now();
    var bar = E.sc.querySelector('.whc__trk i');
    if (bar && t19want) { t19want = false; t19grow(bar, FILL[m.q]); }   /* 19/10 v2: once per opening */
    else if (bar && t19cut) { bar.style.transition = 'none'; bar.style.width = t19cut; requestAnimationFrame(function () { bar.style.transition = ''; }); }
    if (bar) {
      var to = FILL[m.q];
      if (bar.style.width !== to) requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.width = to; }); });
      lastFill = to;
    } else lastFill = null;
    if (fa && !root.contains(d.activeElement)) {
      var f = root.querySelector('[data-whc="' + fa + '"]');
      if (f && !f.disabled) f.focus({ preventScroll: true });
      else if (fa === 'up' || fa === 'inc' || fa === 'dec') { var alt = root.querySelector('[data-whc="dec"]:not([disabled]),[data-whc="inc"]:not([disabled])'); if (alt) alt.focus({ preventScroll: true }); }
    }
    lastM = m;
    tick();
  }
  /* checkout disabled + busy look while the optimistic line waits for the real cart. Only the native disabled state
     (announced as unavailable): an aria-disabled / aria-busy change restyles the whole page here (base theme
     :has([aria-disabled]) rules, measured ~100 ms at 4x CPU in the first frame of the drawer) */
  function pendUI(m) {
    var ov = !!(opt && m && (m === opt.m || m.paBase === opt.m)), on = ov || addOut();   /* 20/10 FIX U1: a page add still out looks pending too. R2 FIX A2: the instant view with a pending line on it too */
    if (root.classList.contains('is-pending') !== on) root.classList.toggle('is-pending', on);
    var pq = on && !opt;   /* 20/10 R2 FIX A2: only a page add out (no instant view): same look, the lines take taps (queued) */
    if (root.classList.contains('whc-pq') !== pq) root.classList.toggle('whc-pq', pq);
    var co = E.ft.querySelector('.whc__co');
    if (co && co.disabled) co.disabled = false; /* 27-09: clickable while pending, checkout() waits for the real cart */
  }
  function tick() {
    if (!E.tmt || !lastM || !lastM.groups.length) return;
    var end = holdEnd(false), left = end ? end - Date.now() : HOLD_MS;
    if (left > 0) {
      var mi = Math.floor(left / 60000), sec = Math.floor(left % 60000 / 1000), txt = mi + ':' + (sec < 10 ? '0' : '') + sec;
      var b = E.tmt.querySelector('b');
      if (b) setText(b, txt); else E.tmt.innerHTML = 'Your cart is reserved for <b>' + txt + '</b>';
    } else {
      /* hold over: no price claim (the price never changes), the cart simply stays saved */
      var msg = lastM.sub && (!bcView(lastM) || bcGuideN(lastM) > 0) ? 'Your cart is saved. Your FREE gifts are ready.' : 'Your cart is saved.';   /* 23/10 B/C F1 */
      if (E.tmt.textContent !== msg) { E.tmt.setAttribute('data-done', ''); setText(E.tmt, msg); }
    }
    if (Date.now() - shipAt >= 30000) {
      shipAt = Date.now();
      var sh = E.sc && E.sc.querySelector('.whc__sh span');
      if (sh) { var st = shipText(); if (sh.innerHTML !== st) setHTML(sh, st); }
    }
  }

  /* header badge (#cartBadge) = paid units like the preview (the gift line is not counted) */
  var shellSet = null, badgeN = null, badgeT = 0;
  function badge(n) {
    clearTimeout(badgeT);
    if (n === badgeN) return;   /* unchanged: no header write (each text swap restyles the page) */
    badgeN = n;
    if (shellSet) shellSet(n);
    else d.querySelectorAll('#cartBadge').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    d.querySelectorAll('.hdr__cartlink').forEach(function (a) { a.setAttribute('aria-label', n ? 'Cart, ' + jarsWord(n) : 'Cart, empty'); });
  }
  /* header badge after the drawer has painted (the shell's pop animation forces a layout) */
  function badgeLater(n) {
    clearTimeout(badgeT);
    if (n === badgeN) return;
    requestAnimationFrame(function () { clearTimeout(badgeT); badgeT = setTimeout(function () { badge(n); }, 0); });
  }
  /* wh1-shell.js writes cart.item_count (gift included) on 'cart:update' / pageshow: map it to the paid count */
  function patchShell() {
    var WH = W.WH;
    if (!WH || WH.__whc || typeof WH.setCart !== 'function') return;
    WH.__whc = true;
    var set = WH.setCart;
    shellSet = function (n) { set.call(WH, n); };
    WH.setCart = function (n) {
      if (cart && +n === cart.item_count) { badgeN = model(cart).count; return set.call(WH, badgeN); }
      badgeN = null; set.call(WH, n); refresh();
    };
    WH.refreshCart = function () { return refresh(); };
  }
  function setCart(c, later) {
    if (!c || !c.items) return false;
    if (stale(c)) return false;   /* 20/10 FIX S1: older than the cart already shown, or asked before a newer write */
    if (c.__s) okSeq = c.__s;
    if (c.__cw != null) cwSeen = c.__cw;   /* 20/10 R1 FIX X1 */
    if (cart && cart.token === c.token && JSON.stringify(cart.items) !== JSON.stringify(c.items)) changed = true;
    cart = c; keptM = null;   /* 19/10 FIX B5: a real cart read */
    if (later) badgeLater(model(c).count); else badge(model(c).count);
    if (!isOpen) schedPrewarm();
    return true;
  }

  /* screen reader line: text data of one text node (no node swap) */
  function say(msg) { if (E.sr) { setText(E.sr, ''); setTimeout(function () { setText(E.sr, msg); }, 30); } }
  function toast(msg, undo) {
    var t = E.toast;
    t.innerHTML = '<span>' + msg + '</span>' + (undo ? '<button type="button" data-whc="undo">Undo</button>' : '');
    t.classList.add('on');
    toastArm(undo ? 5000 : 2600);
  }
  /* 20/10 FIX U2: the hide timer on its own. The Undo toast stays while the removal is saving (removeGroup stops the timer) and gets a
     full 5 s of working Undo from the end of the save; an Undo tapped meanwhile is queued. An Undo toast that runs out forgets the line. */
  function toastArm(ms) {
    var t = E.toast; clearTimeout(t._h);
    t._h = setTimeout(function () { if (!undoQ && t.querySelector('[data-whc="undo"]')) removed = null; t.classList.remove('on'); setTimeout(function () { if (!t.classList.contains('on')) t.innerHTML = ''; }, 250); }, ms);
  }
  function hideToast() { if (!E.toast) return; clearTimeout(E.toast._h); E.toast.classList.remove('on'); E.toast.innerHTML = ''; }

  /* scrollbar width, measured when the page is idle (reading it at open would force a full layout) */
  var sbw = null;
  function measureSbw() { sbw = Math.max(0, innerWidth - d.documentElement.clientWidth); }
  function lock(on) {
    var b = d.body;
    if (on) {
      if (saved) return;
      var sw = sbw != null ? sbw : innerWidth - d.documentElement.clientWidth;
      saved = { o: b.style.overflow, p: b.style.paddingRight };
      b.style.overflow = 'hidden';
      if (sw > 0) b.style.paddingRight = sw + 'px';
    } else if (saved) { b.style.overflow = saved.o; b.style.paddingRight = saved.p; saved = null; }
  }
  function open(from, opts, m0) {
    if ((W.__whGo&&Date.now()-W.__whGo<20000)) return; /* 08-10 direct checkout: no drawer */
    build();
    if (!isOpen) back = from && from.focus ? from : d.activeElement;
    var m = m0 || (opt && opt.shown ? opt.m : busy && lastM ? lastM : keptM || model(cart));   /* 19/10 FIX B5: the kept line, never the stale cache. 20/10 FIX S1: while a change is saving, the view it drew */
    if (m.groups.length) holdEnd(true);
    if (!isOpen) t19want = true;   /* 19/10 v2: the gifts bar grows in once per opening */
    render(m, opts || { top: true });
    root.removeAttribute('inert');
    root.classList.add('is-open'); isOpen = true;
    lock(true);
    clearInterval(timer); timer = setInterval(tick, 1000);
    /* aria-hidden flips with the focus move, just after the first paint: on this page an aria-hidden change restyles
       the whole document (base theme :has([aria-hidden]) rules, ~110 ms at 4x CPU); the drawer is already out of
       the inert state and visible, the focus goes in at the same moment as before (60 ms) */
    setTimeout(function () {
      if (!isOpen) return;
      if (root.getAttribute('aria-hidden') !== 'false') root.setAttribute('aria-hidden', 'false');
      if (!panel.contains(d.activeElement)) try { panel.focus({ preventScroll: true }); } catch (e) { }
    }, 60);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false; closedAt = Date.now(); t19want = false;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); root.setAttribute('inert', '');
    lock(false); clearInterval(timer); hideToast(); hideErr();
    var b = back; back = null;
    if (b && b.focus && d.body.contains(b)) try { b.focus({ preventScroll: true }); } catch (e) { }
    /* the /cart page is server rendered: show the drawer's changes there */
    if (changed && /\/cart\/?$/.test(location.pathname)) location.reload();
    schedPrewarm(700);
  }

  /* ---- refresh: render first, reconcile gifts + shipping in the background (previous drawer) ---- */
  var reqN = 0;
  function refresh(opts) {
    var my = ++reqN, prev = lastM || model(cart);
    return fetchCart().then(function (c) {
      if (my !== reqN || busy || stale(c)) return c;   /* 20/10 FIX S1 */
      if (opt) { cart = c; okSeq = c.__s || okSeq; keptM = null; return c; }   /* an optimistic add is in flight: its own reconcile renders */
      if (!(opts && opts.sw) && swapNeed(c)) { swapFix().then(function () { refresh(assign({}, opts || {}, { sw: 1 })); }); return c; }   /* 20/10 FIX W1: a resize left half done */
      setCart(c);
      var m = model(c);
      if (isOpen) {
        if (m.groups.length) { holdRestartIfOver(); holdEnd(true); }
        render(m, assign({ fresh: fresh(prev, m) }, opts || {}));
        if (m.count > (prev ? prev.count : 0)) hideErr();   /* 19/10 FIX B3: the jar is in after all: no old error line above it */
      }
      ensureGifts(c).then(ensureShipping).then(function (c2) {
        if (c2 && c2 !== c && !busy && !opt && (c2.item_count !== c.item_count || c2.total_price !== c.total_price) && setCart(c2) && isOpen) render(model(c2));   /* 20/10 FIX S1 */
      });
      return c;
    }).catch(function () { loading = false; if (isOpen && !opt) render(keptM || model(cart)); });   /* 19/10 FIX B5 */
  }
  /* 20/10 R4: /cart.js read with up to n more tries (0.6, 1.2 s apart) when it fails (429, 500, network) */
  function rdTry(n, ms) { ms = ms || 600; return fetchCart().catch(function (e) { if (!(n > 0)) throw e; return new Promise(function (ok) { setTimeout(ok, ms); }).then(function () { return rdTry(n - 1, ms * 2); }); }); }
  /* 20/10 R4 FIX F2 (fuzz fz20350PC): a change was saved (or tried) and the cart could not be read afterwards: read it again at 1.5,
     3 and 4.5 s until one read works, so the drawer, the header badge and the cache catch up. Skipped while another change or add is
     out (its own read draws; looked at again 0.5 s later, 20 s max). Was: nothing read the cart again until the visitor acted. */
  var heT = 0;
  function heal(n, w) {
    clearTimeout(heT); n = n || 0; w = w || 0;
    if (n > 2 || w > 40) return;
    heT = setTimeout(function () {
      if (busy || opt || swapRun || tapQ || undoQ || loading || addOut() || afRd > 0) { heal(n, w + 1); return; }
      refresh().then(function (c) { if (!c) heal(n + 1); });
    }, w ? 500 : 1500 * (n + 1));
  }
  function rfh() { return refresh().then(function (c) { if (!c) heal(); return c; }); }
  function openLoading() {
    loading = true;
    if (isOpen) render(keptM || model(cart)); else open(null, { top: true });   /* 19/10 FIX B5 */
  }
  function afterAdd(rt) {
    if (opt) { opt.after = true; return Promise.resolve(); }   /* runs when the optimistic add settles */
    var prev = lastM || model(cart);
    afRd++; var ad = function () { afRd--; };   /* 20/10 FIX U1: checkout waits until the add is drawn */
    var p = fetchCart().then(function (c) {
      loading = false; if (!setCart(c)) return;   /* 20/10 FIX S1: a newer write is on its way, its own read draws */
      var m = model(c);
      if (m.groups.length) { holdRestartIfOver(); holdEnd(true); }
      if (!isOpen) open(null, { top: true, fresh: fresh(prev, m) }); else render(m, { top: true, fresh: fresh(prev, m) });
      addDrawT = Date.now();   /* 20/10 FIX R1 */
      if (m.groups.length > (prev ? prev.groups.length : 0)) hideErr();
      var g = m.primary;
      if (g) say('Added to your cart: ' + g.name + ', ' + (g.jar ? jarsWord(g.jars) : g.jars) + ', ' + money(g.final) + '.');
      ensureGifts(c).then(ensureShipping).then(function (c2) {
        if (c2 && c2 !== c && !busy && !opt && (c2.item_count !== c.item_count || c2.total_price !== c.total_price) && setCart(c2) && isOpen) render(model(c2));   /* 20/10 FIX S1 */
      });
    }).catch(function () { loading = false; if (isOpen) render(keptM || model(cart)); rt = rt || 0; if (rt < 2) setTimeout(function () { if (!opt && !busy && !swapRun) afterAdd(rt + 1); }, 1200 * (rt + 1)); });   /* 19/10 FIX B5. 20/10 FINAL FIX A3: the add happened, its read failed: read again (2 more tries; not while a change is saving: its own read draws, no flash of a line being removed) */
    p.then(ad, ad); return p;
  }

  /* ---- INSTANT CART (product page facade only) ---- */
  function pageHandle() { var mt = location.pathname.match(/\/products\/([^\/?#]+)/); return mt ? decodeURIComponent(mt[1]) : ''; }
  /* the cart as it will be once the offer picked on the page is added: real cart + the new bundle line on top
     (Shopify lists the newest lines first), built with the same fields the real line gets from model() */
  function optGroup(h, nm, n, sub, T) {
    var t = T[n - 1];
    if (!t || !t[0] || !t[1]) return null;
    var price = sub ? t[0] : t[1], unit = (CFG.compareCaps || {})[h] || T[0][1];
    var g = { key: 'opt', lines: [], handle: h, url: '/products/' + h, image: null, variant: null, jars: n, final: price, was: unit * n, sub: sub,
      main: null, P: null, deal: '', name: nm[0], sub2: nm[1] || '', jar: true, kaching: true, opt: true, nx: null };
    var t2 = n < 3 ? T[n] : null;
    if (t2 && t2[0] && t2[1]) { var np = sub ? t2[0] : t2[1]; g.nx = { n: n + 1, jars: n + 1, price: np, diff: np - price }; }
    return g;
  }
  /* ids = Kaching bundle ids of the add request once it is known. Kaching keeps the same id while the offer pick does not
     change: adding the same pick again joins the bundle already in the cart (seen live 27-09: 1 jar + 1 jar = one bundle
     of 2 jars at the 2 jars price), so the prediction grows that bundle instead of adding a line. Past 3 jars (or a plan
     mismatch) there is no reliable guess: the drawer shows the current cart, pending, until the real cart is in. */
  function optModel(st, T, ids) {
    if (!st || !st.ready || !T) return null;
    var h = pageHandle(), nm = (CFG.names || {})[h];
    if (!nm || (CFG.jarHandles || []).indexOf(h) < 0) return null;
    var q = Math.min(3, Math.max(1, +st.q || 0)), sub = !!st.autoship;
    var base = model(cart), m = assign({}, base), same = null, g;
    if (ids && ids.length) base.groups.forEach(function (x) { if (!same && x.kaching && x.P && ids.indexOf(x.P.id) > -1) same = x; });
    if (same) {
      var n = same.jars + q;
      g = same.jar && same.sub === sub && n <= 3 ? optGroup(h, nm, n, sub, T) : null;
      if (!g) { m.keep = true; return m; }
      m.groups = base.groups.map(function (x) { return x === same ? g : x; });
      m.count = base.count - same.jars + n; m.total = base.total - same.final + g.final; m.was = base.was - same.was + g.was;
    } else {
      g = optGroup(h, nm, q, sub, T);
      if (!g) return null;
      m.groups = [g].concat(base.groups);   /* Shopify lists the newest lines first */
      m.count = base.count + q; m.total = base.total + g.final; m.was = base.was + g.was;
    }
    m.save = Math.max(0, m.was - m.total);
    m.primary = primOf(m.groups);   /* 20/10 FINAL FIX L1 */
    m.wb = !!m.primary.wb;   /* 20/10 FINAL FIX L2: an A add on a cart with an old B jar is an A add (no B poll on failure) */
    m.q = Math.min(3, m.primary.jars); m.sub = !!(m.primary.jar && (m.primary.sub || document.documentElement.classList.contains('wh1-nosub')));
    return m;
  }
  /* Kaching bundle ids in the add request body (FormData from the product form, or JSON items) */
  function kcIds(body) {
    var ids = [];
    var one = function (v) { try { var P = typeof v === 'string' ? JSON.parse(v) : v; if (P && P.id && ids.indexOf(P.id) < 0) ids.push(P.id); } catch (e) { } };
    try {
      if (typeof body === 'string') { var j = JSON.parse(body); (j.items || [j]).forEach(function (it) { one(it && it.properties && it.properties.__kaching_bundles); }); }
      else if (body && typeof body.forEach === 'function') body.forEach(function (v, k) { if (/__kaching_bundles\]$/.test(k)) one(v); });
    } catch (e) { }
    return ids;
  }
  /* the add request is known: redo the prediction with its bundle ids (re-render only when it changed) */
  function optIds(o, body) {
    var ids = kcIds(body), m2;
    if (!ids.length) return;
    try { m2 = optModel(o.st, W.WH1P && W.WH1P.T, ids); } catch (e) { return; }
    if (!m2 || opt !== o) return;
    var sig = function (m) { return m.groups.length + ':' + m.count + ':' + m.total + ':' + !!m.keep; };
    if (sig(m2) === sig(o.m)) return;
    o.m = m2; o.fresh = fresh(o.prev, m2);
    if (o.shown && isOpen) render(m2, { fresh: o.fresh });
  }
  /* 20/10 FIX P1 (phantom 2nd bundle). wh1-product.js lets one click of the form button through every 3 s ("29-09 anti
     double-click") while #atc is busy for only 1.5 s: a 2nd Add to cart between 1.5 and 3 s drew a 2nd bundle that was never sent,
     then "Sorry, that did not go through" 4 s later. The same rule is mirrored here (window capture: runs before that guard and sees
     every click): such a tap draws nothing, and a form click the guard swallowed ends a pending view at once, without the error. */
  var pfLast = 0, pfDrop = 0;
  W.addEventListener('click', function (e) { var t = e.target; if (!t || !t.closest || !t.closest('.wh1-pform__btn')) return; var n = Date.now(); if (n - pfLast < 3000) pfDrop = n; else pfLast = n; }, true);
  /* 20/10 FIX R1 (retap): where and when the last real Add to cart tap was (#atc, sticky bar, final offer, B button). The 2nd tap of an
     impatient double tap lands on the drawer that just opened under the finger (+, upgrade, trash at that spot): see onClick. */
  W.addEventListener('click', function (e) { var t = e.target; if (e.isTrusted && t && t.closest && t.closest('#atc,.sb6__btn,.fo__atc')) atcTap = { t: Date.now(), x: e.clientX, y: e.clientY }; }, true);
  function dropOpt(o) {
    if (opt !== o) return;
    opt = null; clearTimeout(o.wd);
    if (isOpen) { render(keptM || model(cart), { top: true }); addDrawT = Date.now(); }
    if (o.after) afterAdd();
  }
  function onAtcClick(e) {
    var P = W.WH1P;
    if (W.WH_DIRECT && W.WH_DIRECT()) { var t0 = e.target, a0 = t0 && t0.closest ? t0.closest('#atc,.sb6__btn,.fo__atc,.wh1-pform__btn') : null; if (a0) { W.__whGo = Date.now(); a0.classList.add('is-go'); var tx = a0.querySelector('span') || a0; try { a0.setAttribute('data-txt', tx.textContent); tx.textContent = 'Loading…'; } catch (x) { } } return; }
    if (!P || typeof P.state !== 'function') return;
    var t = e.target, a = t && t.closest ? t.closest('#atc,.sb6__btn,.fo__atc') : null;
    if (!a || !a.closest('.wh1-pc') || !d.getElementById('wh1-pform')) return;
    /* 20/10 FIX P1 + R4 FIX P3 (hard verifier, owner scenario, also live v2: Add to cart, drawer closed while that add was still out,
       Add to cart again 1-2 s later = nothing at all): an add still out (instant view, page add, change saving) or the page's double-tap
       guards (button busy 1.5 s, form 3 s) = this tap adds nothing: the drawer opens on the cart as it is (the pending add included) */
    if (opt || busy || loading || a.classList.contains('is-busy') || Date.now() - pfLast < 3000) { if (!isOpen) { open(a); if (!opt && !busy && !loading && !addOut()) refresh(); } return; }
    var st, m;
    try { st = P.state(); m = optModel(st, P.T); } catch (x) { return; }
    if (!m) return;
    var o = opt = { m: m, st: st, prev: model(cart), shown: false, req: false, after: false };
    o.fresh = fresh(o.prev, m);
    var go = function () { if (opt === o && !o.shown) showOpt(o); };
    requestAnimationFrame(go); setTimeout(go, 100);
    /* no add request (the page could not submit): give the previous view back */
    o.t0 = Date.now();
    o.wd = setTimeout(function () { if (opt === o && !o.req) { if (pfDrop >= o.t0) dropOpt(o); else addFail(o); } }, 4000);
    (function pw() { if (opt !== o || o.req) return; if (pfDrop >= o.t0) { dropOpt(o); return; } if (Date.now() - o.t0 < 4000) setTimeout(pw, 150); })();   /* 20/10 FIX P1 */
  }
  function showOpt(o) {
    o.shown = true; hideErr(); hideToast();
    holdRestartIfOver();
    if (!isOpen) open(null, { top: true, fresh: o.fresh }, o.m); else { holdEnd(true); render(o.m, { top: true, fresh: o.fresh }); }
  }
  function bindAdd(o) {
    o.req = true; clearTimeout(o.wd);
    if (o.bp === 'run') { o.bp = ''; o.bpg = (o.bpg || 0) + 1; }   /* 19/10 FIX B3: a request started during the wait: it decides */
    /* still no answer after 25 s: take whatever the cart says */
    o.wd = setTimeout(function () { if (opt === o) settleFromServer(o); }, 25000);
  }
  function addDone(o, ok) {
    if (opt !== o) return;
    if (!ok) return addFail(o);
    o.ok = true;
    fetchCart().then(function (c) { reconcile(o, c); }, function () {
      setTimeout(function () { if (opt === o) fetchCart().then(function (c) { reconcile(o, c); }, function () { if (opt === o) settle(o); }); }, 1200);
    });
  }
  /* the add went through but the cart could not be read: keep the line, allow checkout */
  function settle(o) {
    opt = null; clearTimeout(o.wd);
    if (!o.m.keep) { keptM = o.m; badge(o.m.count); }   /* 19/10 FIX B5: Shopify accepted the add: this line is the last known cart until a real read. 20/10 R1 FIX K1: the header badge too (it stayed at the old count) */
    if (isOpen && lastM === o.m) pendUI(o.m);
    if (o.after) afterAdd();
  }
  function reconcile(o, c) {
    if (opt !== o) return;
    if (stale(c)) { fetchCart().then(function (c2) { reconcile(o, c2); }, function () { if (opt === o) settle(o); }); return; }   /* 20/10 FIX S1: a write started after this read: read again */
    opt = null; clearTimeout(o.wd);
    setCart(c, true);
    var m = model(c);
    if (isOpen) {
      if (m.groups.length) { holdRestartIfOver(); holdEnd(true); }
      render(m, { fresh: o.fresh });   /* same gift rows as the optimistic view: nothing replays, nothing jumps */
      addDrawT = Date.now();   /* 20/10 FIX R1 */
    }
    var g = m.primary;
    if (g) say('Added to your cart: ' + g.name + ', ' + (g.jar ? jarsWord(g.jars) : g.jars) + ', ' + money(g.final) + '.');
    ensureGifts(c).then(ensureShipping).then(function (c2) {
      if (c2 && c2 !== c && !busy && !opt && (c2.item_count !== c.item_count || c2.total_price !== c.total_price) && setCart(c2) && isOpen) render(model(c2));   /* 20/10 FIX S1 */
    });
    if (o.after) afterAdd();
  }
  /* 19/10 FIX B3 (B add failure). The B add reported an error (or no answer): Kaching resends on a network error and the add can have
     gone through anyway. No "Sorry ... try again" and no Add button yet: the B jar stays on screen (pending) while /cart.js is read
     at about 0.5, 1.5, 3 and 4 s; the jar shows as soon as the cart has it. Still not in the cart after 4 s and no resend of Kaching
     still out or still to come (addFly / addSeq / addEnd, waited for up to 8 s): the error, as before.
     A request that starts during the wait takes over (bindAdd). */
  function bPoll(o) {
    o.bp = 'run'; clearTimeout(o.wd);
    var t0 = Date.now(), s0 = addSeq - 1, at = [500, 1500, 3000, 4000], i = 0, gen = o.bpg = (o.bpg || 0) + 1;
    var mine = function () { return opt === o && o.bpg === gen; };
    (function step() {
      if (!mine()) return;
      /* past 4 s: wait (max 8 s) while a page add is still out, or while Kaching may still resend: fewer than its 3 sends so far and
         the last answer < 1.6 s ago (it resends ~1.4 s after a failed send) */
      var due = i < at.length ? t0 + at[i++] : Date.now() - t0 < 8000 && (addFly > 0 || (addSeq - s0 < 3 && Date.now() - addEnd < 1600)) ? Date.now() + 500 : 0;
      if (!due) { o.bp = 'done'; addFail(o); return; }
      o.wd = setTimeout(function () {
        if (!mine()) return;
        fetchCart().then(function (c) { if (!mine()) return; if (model(c).count > o.prev.count) reconcile(o, c); else step(); }, function () { if (mine()) step(); });
      }, Math.max(0, due - Date.now()));
    })();
  }
  function addFail(o) {
    if (opt !== o) return;
    if (o.m && o.m.wb && o.bp !== 'done') { if (o.bp !== 'run') bPoll(o); return; }   /* 19/10 FIX B3: B, look for the jar first */
    opt = null; clearTimeout(o.wd);
    var before = keptM || model(cart);   /* 19/10 FIX B5 */
    if (!isOpen) open(null, { top: true }, before); else render(before, { top: true });
    showErr(ERR_ADD);
    /* re-read the cart: a network error can hide an add that did go through */
    fetchCart().then(function (c) {
      if (opt || !setCart(c)) return;   /* 20/10 FIX S1 */
      var m = model(c);
      if (isOpen) render(m);
      if (m.count > before.count) hideErr();
    }).catch(function () { });
    if (o.after) afterAdd();
  }
  function settleFromServer(o) {
    fetchCart().then(function (c) {
      if (opt !== o) return;
      var had = o.prev.count, m = model(c);
      if (m.count > had) reconcile(o, c); else addFail(o);
    }, function () { if (opt === o) addFail(o); });
  }

  /* pre-render the line of the current offer into the closed drawer (hidden + inert) when the page is idle */
  var addFly = 0, addSeq = 0, addEnd = 0;   /* 19/10 FIX B3: page add requests still out / sent / last answered (Kaching's first send and its resends) */
  var pwT = 0;
  function schedPrewarm(delay) {
    if (!W.WH1P || !root) return;
    clearTimeout(pwT);
    pwT = setTimeout(function () {
      var ric = W.requestIdleCallback || function (f) { return setTimeout(f, 1); };
      ric(prewarm, { timeout: 1500 });
    }, delay == null ? 350 : delay);
  }
  var pwTry = 0;
  function prewarm() {
    if (isOpen || opt || busy || loading || !root || !W.WH1P || Date.now() - closedAt < 600) return;
    var st, m;
    try { st = W.WH1P.state(); } catch (e) { return; }
    if (!st || !st.ready) { if (++pwTry < 20) schedPrewarm(1000); return; }   /* Kaching prices not in yet */
    try { m = optModel(st, W.WH1P.T); } catch (e) { return; }
    if (m) render(m, { top: true, pre: true });
  }

  /* ---- gifts: auto add when a paid item exists, strip when none (previous drawer; only change: no add attempt
     for a gift that requires a selling plan, which always failed with a 422 and logged a console error) ---- */
  /* product .js of a gift, read once per page (instant cart 27-09: a one-time cart used to refetch it plus
     /cart.js after every add and every drawer refresh, for a plan-only gift that is never added) */
  var pjs = {};
  function productJs(h) {
    if (!pjs[h]) { pjs[h] = origFetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); pjs[h].catch(function () { delete pjs[h]; }); }
    return pjs[h];
  }
  /* 19/10 FIX B2 (Adrien: "it went in twice"). A B cart (the one-bar Kaching arm: cartB / isB1, the same detection as the drawer's
     B layout) holds ONE B jar bundle. A resent add (Kaching resends on a network error) can leave the B jar line at quantity 2, or a
     2nd B jar line: back to one jar (the first one added: Shopify lists the newest line first) and one guide, in ONE request
     (change.js for one line, update.js for several). Never on an A cart: any paid line that is not a B bundle line, or a B bar that
     is not a plain quantity bar = no change at all. No loop: one request per cart state (token + the planned change), at most 3 per
     page; checkout waits for it (bfRun) and for a /cart.js read still out on a B cart (rdN). The server's answer decides the memo
     (bfAfter): fix taken = the state is forgotten, so the same doubling coming back later (a later Kaching resend) is fixed again;
     same bad cart in the answer = the server ignored it: that state is never sent again, not even after a reload (sessionStorage). */
  var bfSeen = {}, bfN = 0, bfRun = false, BFK = 'whc_bfs';
  try { (JSON.parse(sessionStorage.getItem(BFK) || '[]') || []).forEach(function (s) { bfSeen[s] = 1; }); } catch (e) { }
  function bSig(c, upd) { return (c.token || '') + '|' + Object.keys(upd).sort().map(function (k) { return k + '=' + upd[k]; }).join(','); }
  function bfAfter(sig, ans) {
    var p = ans && ans.items ? bPlan(ans) : undefined, stuck = !!(p && bSig(ans, p) === sig);
    if (p === undefined) return;   /* no readable answer (network error, 4xx): this state is not sent again on this page */
    if (stuck) bfSeen[sig] = 1; else delete bfSeen[sig];
    try { var a = (JSON.parse(sessionStorage.getItem(BFK) || '[]') || []).filter(function (s) { return s !== sig; }); if (stuck) a.push(sig); if (a.length) sessionStorage.setItem(BFK, JSON.stringify(a.slice(-10))); else sessionStorage.removeItem(BFK); } catch (e) { }
  }
  function bPlan(c) {
    if (!c || !c.items || !cartB(c)) return null;
    var jars = [], other = false;
    c.items.forEach(function (it) {
      if (isHidden(it.handle)) return;
      var P = kp(it);
      if (P && P.main && !P.bxgy && isB1(P)) jars.push({ it: it, P: P }); else other = true;
    });
    if (other || !jars.length) return null;
    var keep = jars[jars.length - 1], bar = { n: 1 };   /* 20/10 FINAL FIX L1: only old B/C/D arms get here (LEGACY_B): each sold one bar of 1 jar */
    var upd = {}, n = 0, drop = {};
    if (keep.it.quantity > bar.n) { upd[keep.it.key] = bar.n; n++; }
    jars.forEach(function (x) { if (x !== keep) { upd[x.it.key] = 0; n++; if (x.P.id && x.P.id !== keep.P.id) drop[x.P.id] = 1; } });
    if (!n) return null;
    GIFT_H.forEach(function (h) {   /* one line per gift: the kept bundle's own, else a Kaching one of a kept bundle, else the first */
      var gs = c.items.filter(function (it) { return it.handle === h; }), kg = null;
      gs.forEach(function (g) { var P = kp(g); if (!kg && P && P.id === keep.P.id) kg = g; });
      gs.forEach(function (g) { var P = kp(g); if (!kg && P && !drop[P.id]) kg = g; });
      gs.forEach(function (g) { var P = kp(g); if (!kg && !(P && drop[P.id])) kg = g; });
      if (!kg) kg = gs[0];
      gs.forEach(function (g) { if (g !== kg) upd[g.key] = 0; else if (g.quantity > 1) upd[g.key] = 1; });
    });
    return upd;
  }
  function bFix(c) {
    var upd = bPlan(c);
    if (!upd) return null;
    var keys = Object.keys(upd).sort(), sig = bSig(c, upd);
    if (bfSeen[sig] || bfN >= 3) return false;   /* this state is being corrected / the server ignored it: no 2nd request, no other write for it */
    bfSeen[sig] = 1; bfN++;
    W.__whcBfix = (W.__whcBfix || 0) + 1;   /* count of guard requests (tests) */
    return keys.length === 1 ? ['/cart/change.js', { id: keys[0], quantity: upd[keys[0]] }, sig] : ['/cart/update.js', { updates: upd }, sig];
  }
  function ensureGifts(c) {
    if (!GIFT_H.length || ensureGiftsRunning || busy) return Promise.resolve(c);
    var gifts = c.items.filter(function (i) { return isGift(i.handle); });
    var hasPaid = c.items.some(function (i) { return !isHidden(i.handle); });
    var chain = Promise.resolve(), wrote = false, bf = null;
    if (!hasPaid) {
      if (!gifts.length) return Promise.resolve(c);
      ensureGiftsRunning = true; wrote = true;
      gifts.forEach(function (g) { chain = chain.then(function () { return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: g.key, quantity: 0 }) }); }); });
    } else if ((bf = bFix(c)) !== null) {
      /* 19/10 FIX B2: the B cart guard alone in this pass (ONE request), then ONE more pass on the fresh cart (the usual gift step,
         or a doubling that came back meanwhile: bounded by the memo and the 3 per page). Same B state again after the server
         ignored the fix: nothing at all is sent, so nothing can loop. bfRun holds checkout until both passes are done. */
      if (!bf) return Promise.resolve(c);
      ensureGiftsRunning = true; wrote = true; bfRun = true;
      chain = chain.then(function () { return origFetch(bf[0], { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(bf[1]) }); })
        .then(function (r) { return r && r.ok ? r.json().then(function (j) { bfAfter(bf[2], j); }, function () { }) : null; });
    } else {
      /* 20/10 R1 FIX G1 (the guide = the offer's rule, as Kaching and the drawer show it: the "Buy 1 only" bar has no gift, the drawer says
         "Get your 2nd jar FREE to unlock the $29 Guide"). The theme adds the guide only when the drawer shows it unlocked (2+ jars, or the
         B jar), and removes a guide line IT added (no Kaching tag) below that, or when a Kaching bundle brings its own (one line per gift:
         a 1-jar cart taken to 2 jars had 2 guide lines). A line tagged by Kaching is never removed. Was: the guide added to every 1-jar
         cart (checkout got it while the drawer said "locked"). GUIDE_AT_1 = true (build_v3.py) = the old rule. */
      /* 20/10 FINAL FIX G2 (owner 20/10, as the page promises: 1 jar = no guide, 2 jars = guide, 3 jars = guide + mystery gift).
         Wanted when a bundle of the cart qualifies (2+ jars, or an old offer B jar). A line Kaching tagged for a bundle that is in the
         cart belongs to it: kept (a 2nd guide line of the SAME bundle goes). A line with no tag, or tagged for a bundle no longer in the
         cart, is the theme's: one is kept only when wanted and no bundle line brought one; removed otherwise (1-jar cart, or a bundle
         that brings its own). Never two guide lines for one bundle. */
      var mq = model(c), own = {}, qual = false;
      mq.groups.forEach(function (g) { if (g.P && g.P.id) own[g.P.id] = 1; if (g.jar && (g.wb || g.jars >= GIFTS[1].need)) qual = true; });
      var want = GUIDE_AT_1 || qual;
      var tagOf = function (g) { var P = kp(g); return P && P.id && own[P.id] ? P.id : ''; };
      var keep = {}, seen = {}, dup = [];
      gifts.forEach(function (g) { var t = tagOf(g), sk = g.handle + '|' + t; if (!t) return; if (seen[sk]) dup.push(g); else { seen[sk] = 1; if (!keep[g.handle]) keep[g.handle] = g; } });
      gifts.forEach(function (g) { if (tagOf(g)) return; if (want && !keep[g.handle]) keep[g.handle] = g; else dup.push(g); });
      var missing = want ? GIFT_H.filter(function (h) { return !keep[h]; }) : [];
      var over = gifts.filter(function (g) { return g.quantity > 1 && dup.indexOf(g) < 0; });
      if (!missing.length && !over.length && !dup.length) return Promise.resolve(c);
      ensureGiftsRunning = true;
      over.forEach(function (g) { wrote = true; chain = chain.then(function () { return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: g.key, quantity: 1 }) }); }); });
      dup.forEach(function (g) { wrote = true; chain = chain.then(function () { return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: g.key, quantity: 0 }) }); }); });
      missing.forEach(function (h) { chain = chain.then(function () { return productJs(h).then(function (p) { if (!p || !p.variants || !p.variants.length) return; var gsp = null; if (p.requires_selling_plan) { try { gsp = p.selling_plan_groups[0].selling_plans[0].id; } catch (e) { } if (!gsp) return; }   /* a plan-only gift cannot be added alone (Shopify 422): Kaching adds it with its plan */ wrote = true; return origFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [gsp ? { id: p.variants[0].id, quantity: 1, selling_plan: gsp } : { id: p.variants[0].id, quantity: 1 }] }) }); }).catch(function () { }); }); });
    }
    return chain.then(function () { return wrote ? fetchCart() : c; }).then(function (c2) { ensureGiftsRunning = false; return bf && c2 && c2 !== c && c2.items ? ensureGifts(c2) : c2; })   /* 19/10 FIX B2: one pass more after the guard */
      .then(function (c2) { ensureGiftsRunning = false; if (bf) bfRun = false; return c2; }, function () { ensureGiftsRunning = false; if (bf) bfRun = false; return c; });
  }
  /* ---- shipping protection: toggle-driven, opt-in remembered (previous drawer, unchanged) ---- */
  function shipWanted() { try { return localStorage.getItem(SHIPKEY) === 'on'; } catch (e) { return false; } }
  function ensureShipping(c) {
    if (!SHIP_H || ensureShipRunning || busy) return Promise.resolve(c);
    var hasPaid = c.items.some(function (i) { return !isHidden(i.handle); });
    var line = c.items.filter(function (i) { return i.handle === SHIP_H; })[0];
    var wanted = shipWanted();
    var needAdd = hasPaid && wanted && !line;
    var needRm = (!hasPaid || !wanted) && line;
    if (!needAdd && !needRm) return Promise.resolve(c);
    ensureShipRunning = true;
    var step = needAdd
      ? origFetch('/products/' + SHIP_H + '.js').then(function (r) { return r.json(); }).then(function (p) { if (!p || !p.variants || !p.variants.length) return; return origFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] }) }); })
      : origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
    return step.then(fetchCart).then(function (c2) { ensureShipRunning = false; return c2; }).catch(function () { ensureShipRunning = false; return c; });
  }
  function toggleShipping(want) {
    try { localStorage.setItem(SHIPKEY, want ? 'on' : 'off'); } catch (e) { }
    busy++; wBump();   /* 20/10 FIX S1 */
    return fetchCart().then(function (c) {
      var line = c.items.filter(function (i) { return i.handle === SHIP_H; })[0];
      if (want && !line) return origFetch('/products/' + SHIP_H + '.js').then(function (r) { return r.json(); }).then(function (p) { return post('/cart/add.js', { items: [{ id: p.variants[0].id, quantity: 1 }] }); });
      if (!want && line) return post('/cart/change.js', { id: line.key, quantity: 0 });
    }).catch(function () { }).then(function () { busy--; return refresh(); });
  }

  /* ---- cart writes ---- */
  /* items to put a group back exactly as it was (Undo, failed swap): free lines, gifts, then the paid line */
  function groupLines(g) {
    var ids = {}, keys = [];
    g.lines.forEach(function (it) { keys.push(it.key); var P = kp(it); if (P && P.id) ids[P.id] = 1; });
    var gifts = (cart ? cart.items : []).filter(function (it) { var P = kp(it); return isGift(it.handle) && P && ids[P.id]; });
    gifts.forEach(function (it) { keys.push(it.key); });
    return { keys: keys, gifts: gifts };
  }
  function lineItem(it, parent) {
    var props = {}, p = it.properties || {};
    for (var k in p) if (p[k] != null && p[k] !== '') props[k] = p[k];
    var o = { id: it.variant_id, quantity: it.quantity, properties: props };
    var sp = spOf(it); if (sp) o.selling_plan = sp;
    if (parent) o.parent_id = parent;
    return o;
  }
  function restoreItems(g) {
    var gl = groupLines(g), mainV = g.main ? g.main.variant_id : null, out = [];
    g.lines.forEach(function (it) { if (it !== g.main) out.push(lineItem(it)); });
    gl.gifts.forEach(function (it) { out.push(lineItem(it, mainV)); });
    if (g.main) out.push(lineItem(g.main));
    return out;
  }
  function giftVariant(pid) {
    var it = (cart ? cart.items : []).filter(function (i) { return i.product_id === pid; })[0];
    if (it) return { id: it.variant_id, sp: spOf(it) };
    var g = (CFG.gifts || {})[pid];
    return g && g.id ? { id: g.id, sp: g.sp } : null;
  }
  /* the same bundle at a new size, in Kaching's own cart format (tested against Kaching's discount) */
  function bundleItems(g, n) {
    var dl = kDeal(g.P), bar = barFor(dl, n);
    if (!bar || !g.main || !g.P) return null;
    var main = g.main, P = g.P, sp = spOf(main), id = rid(), items = [];
    var bsp = bcPlan(g, bar, sp), nsp = bsp || sp;   /* 23/10 B/C F3: the new bar's selling plan (arm A: 0 = the line's own, as before) */
    var cur = dl.v && P.v && dl.v !== P.v ? { v: dl.v, abid: dl.abid || P.abid, ab: dl.ab || P.ab } : {};   /* 21/10 R5 FIX K2: a line of an older Kaching version resized on its arm's live settings = written as a fresh add of the live offer (live version + arm) */
    var base = assign({ id: id, deal: P.deal, v: P.v, abid: P.abid, ab: P.ab }, cur);
    if (bar.get) {
      var fl = g.lines.filter(function (it) { var q = kp(it); return q && q.bxgy; })[0], fp = fl ? kp(fl) : null;
      var free = fp ? assign({}, fp, cur, { id: id, bar: bar.id }) : assign({}, base, { bar: bar.id, main: true, bxgy: true });   /* 21/10 R5 FIX K2: + cur */
      var fi = { id: main.variant_id, quantity: bar.get, properties: { __kaching_bundles: JSON.stringify(free) } };
      if (nsp) fi.selling_plan = nsp;
      items.push(fi);
    }
    (GUIDE_AT_1 || n >= GIFTS[1].need || bcArm(g) ? bar.gifts : []).forEach(function (gf) {   /* 23/10 B/C F2: a B / C bar's own gifts at any size */   /* 27-09: gifts kept on resize even without subscription (gift has its own plan). 20/10 FINAL FIX G2: never on 1 jar (a stale saved bar can list one) */
      var v = giftVariant(gf.pid);
      if (!v || !v.id) return;
      var gi = { id: v.id, quantity: gf.q || 1, parent_id: main.variant_id, properties: { __kaching_bundles: JSON.stringify(assign({}, base, { gift: gf.id })) } };
      if (v.sp) gi.selling_plan = v.sp;
      items.push(gi);
    });
    var props = {}, mp = main.properties || {};
    for (var k in mp) if (mp[k] != null && mp[k] !== '') props[k] = mp[k];
    props.__kaching_bundles = JSON.stringify(assign({}, P, cur, { id: id, bar: bar.id }, bsp && P.sellingPlan && typeof P.sellingPlan === 'object' ? { sellingPlan: assign({}, P.sellingPlan, { id: bsp }) } : null));   /* 21/10 R5 FIX K2: + cur. 23/10 B/C F3: + the new plan */
    var mi = { id: main.variant_id, quantity: bar.buy, properties: props };
    if (nsp) mi.selling_plan = nsp;
    items.push(mi);
    return { items: items, bar: bar, price: barPrice(bar, unitWas(main), P), id: id };   /* 20/10 FIX W1: the new bundle id (swap journal) */
  }
  /* optimistic model: the drawer shows the new size at once, the cart catches up in the background */
  function predict(m, g, n, price) {
    var p = assign({}, m), ng = assign({}, g), unit = g.jars ? g.was / g.jars : 0;
    ng.jars = n; ng.was = Math.round(unit * n);
    if (price != null) ng.final = price;
    p.groups = m.groups.map(function (x) { return x === g ? ng : x; });
    if (m.primary === g) p.primary = ng;
    p.count = m.count - g.jars + n;
    p.total = m.total - g.final + ng.final;
    p.was = m.was - g.was + ng.was;
    p.save = Math.max(0, p.was - p.total);
    if (p.primary === ng) p.q = Math.min(3, n);
    return p;
  }
  /* 20/10 FIX W1 (a resize = add the new bundle, then remove the old lines: 2 requests). Journal (localStorage whc_swap, 30 min):
     new bundle id + old line keys. swapNeed(c): the new bundle is in the cart AND an old line is still there = the 2nd request was
     lost; swapFix() removes those old lines (3 tries, longer wait after a 429). A cart without the new bundle is never touched. */
  var SWAPK = 'whc_swap', swapRun = null, swapMem = null, swapRuns = 0;   /* swapMem: the same journal in memory (storage blocked) */
  function swapGet() { var j = null; try { j = JSON.parse(localStorage.getItem(SWAPK)) || swapMem; } catch (e) { j = swapMem; } return j && j.id && j.kill && Date.now() - (j.t || 0) < 18e5 ? j : null; }
  function swapSave(j) { swapMem = j || null; try { if (j) localStorage.setItem(SWAPK, JSON.stringify(j)); else localStorage.removeItem(SWAPK); } catch (e) { } }
  function swapHas(c, J) { return !!(c && c.items && c.items.some(function (it) { var P = kp(it); return P && P.id === J.id; })); }
  function swapNeed(c) { var J = swapGet(); return !!(J && swapHas(c, J) && c.items.some(function (it) { return J.kill.indexOf(it.key) > -1; })); }
  function swapFix() {
    if (swapRun) return swapRun;
    var J = swapGet();
    if (!J) { swapSave(null); return Promise.resolve('none'); }
    var sj = null, sg = -1; swapRuns++;   /* 21/10 R7 FIX C5: the answer of the removal (the whole cart) + its write generation; runs counted (checkout) */
    busy++; busyUI(true);
    swapRun = fetchCart().then(function (c) {
      var old = c.items.filter(function (it) { return J.kill.indexOf(it.key) > -1; });
      if (!swapHas(c, J)) { if (!old.length || Date.now() - J.t > 6e4) swapSave(null); return 'none'; }   /* the add did not land (yet) */
      if (!old.length) { swapSave(null); setCart(c); return 'done'; }   /* 20/10 FINAL FIX Q3 (r11258A): this read is the cart (asked after the change started): kept */
      var upd = {}, n = 0; old.forEach(function (it) { upd[it.key] = 0; });
      wBump(); sg = wg;
      return (function again() {
        return post('/cart/update.js', { updates: upd }).then(function (j) { swapSave(null); sj = j; return 'done'; }, function (e) {
          if (++n >= 3) { swapSave(null); return 'fail'; }   /* the drawer shows both lines: the visitor decides */
          return new Promise(function (ok) { setTimeout(ok, (e && e.status === 429 ? 3000 : 1200) * n); }).then(again);
        });
      })();
    }, function () { return 'err'; }).then(function (r) { busy--; busyUI(false); swapRun = null; if (sj) wjUse(sj, sg, busy > 0); return r; });   /* 21/10 R7 FIX C5a: the cart after the removal is the cache (was: thrown away, a checkout compared the old cart) */
    return swapRun;
  }
  /* 20/10 FIX U1: page add still out (cap 20 s: a hung request never freezes the drawer); run fn once no change is saving (cap 30 s) */
  function addOut() { return addFly > 0 && Date.now() - addT0 < 20000; }
  function idleDo(fn) { var n = 0; (function w() { if ((busy || swapRun) && ++n < 300) { setTimeout(w, 100); return; } fn(); })(); }
  function lateAdd() { if (removed) { removed = null; undoQ = false; hideToast(); } afterAdd(); }
  /* 20/10 R2 FIX A2 (untracked-add-while-busy, re-check r7b). A 2nd Add to cart sent while the 1st add still holds the instant view
     (its answer in, its cart read still out) was not drawn: the drawer showed 1 bundle, the trash on it was dropped, then the 2nd
     bundle landed (YOUR CART 4: more jars after a trash than before). Now that add gets its own pending line on top (Shopify lists the
     newest line first), built like the instant view from the offer picked on the page and its Kaching bundle id, until a /cart.js read
     asked after its answer is in (cap 20 s out, 8 s after). A tap on it is queued (FIX T1) and applied to that bundle once it is in. */
  var pa = null, EVT = !!(W.performance && performance.now);
  /* 20/10 R2 FIX Q2: time of a tap as the device saw it (event time), not when the page got to handle it */
  function evTs(e) { if (!EVT) return Date.now(); var t = e && +e.timeStamp; return t > 0 && t < 1e11 ? t : performance.now(); }
  function paG(a, n) { var g = optGroup(a.h, a.nm, n, a.sub, a.T); if (g) { g.key = 'pa'; g.pa = a; } return g; }
  function paLive() {
    var a = pa; if (!a) return false;
    if (a.out ? Date.now() - a.t0 < 20000 : okSeq <= a.rs && Date.now() - a.te < 8000) return true;
    pa = null; return false;
  }
  function paOn() { return !!(lastM && lastM.groups && lastM.groups.some(function (x) { return x.pa; })); }
  function paRe(m, groups, dj, dt, dw) {
    var v = assign({}, m); v.groups = groups;
    v.count = m.count + dj; v.total = m.total + dt; v.was = m.was + dw; v.save = Math.max(0, v.was - v.total);
    v.primary = primOf(groups);   /* 20/10 FINAL FIX L1 */
    v.q = v.primary ? Math.min(3, v.primary.jars) : 0;
    v.sub = !!(v.primary && v.primary.jar && (v.primary.sub || (v.giftLines && v.giftLines.length) || d.documentElement.classList.contains('wh1-nosub')));
    if (v.primary && v.primary.wb) v.q = 3;
    v.gdx = groups.some(function (x) { return x.pa && x.jars >= GIFTS[1].need; }) ? 1 : 0;   /* its bundle brings its own guide line */
    v.paBase = m.paBase || m;
    return v;
  }
  function paView(m) {
    if (!m || !m.groups || m.keep) return m;
    var a = pa, live = paLive(), x = null;
    m.groups.forEach(function (y) { if (y.pa) x = y; });
    if (x) {
      if (!live || x.pa !== a || a.gone) return paRe(m, m.groups.filter(function (y) { return y !== x; }), -x.jars, -x.final, -x.was);   /* an old pending line: off */
      return x === a.g ? m : paRe(m, m.groups.map(function (y) { return y === x ? a.g : y; }), a.g.jars - x.jars, a.g.final - x.final, a.g.was - x.was);
    }
    if (!live || a.gone || m.groups.some(function (y) { return y.P && y.P.id && a.ids.indexOf(y.P.id) > -1; })) return m;   /* its bundle is in the cart (or joins one): the real line */
    return paRe(m, [a.g].concat(m.groups), a.g.jars, a.g.final, a.g.was);
  }
  function paSize(m, g, n) {
    var a = g.pa, g2 = paG(a, n); if (!g2) return m;
    a.g = g2;
    return paRe(m, m.groups.map(function (x) { return x === g ? g2 : x; }), n - g.jars, g2.final - g.final, g2.was - g.was);
  }
  function paNew(body, pr) {
    var o = opt, P = W.WH1P, ids = kcIds(body), st, h, nm, a, g;
    if (!o || (o.m && o.m.wb) || cartB(cart) || !P || typeof P.state !== 'function' || !P.T || !ids.length || !onPdp()) return;
    try { st = P.state(); } catch (e) { return; }
    h = pageHandle(); nm = (CFG.names || {})[h];
    if (!st || !st.ready || !nm || (CFG.jarHandles || []).indexOf(h) < 0) return;
    a = { ids: ids, h: h, nm: nm, sub: !!st.autoship, T: P.T, out: true, gone: false, t0: Date.now(), rs: 0, te: 0 };
    g = paG(a, Math.min(3, Math.max(1, +st.q || 0))); if (!g) return;
    a.g = g; pa = a;
    var end = function () { a.out = false; a.rs = rdSeq; a.te = Date.now(); };   /* runs before its afterAdd (registered first): that read is the one */
    pr.then(end, end);
    if (isOpen && lastM) render(lastM);
  }
  /* 20/10 R2 FIX T2: the taps still queued, shown on any view drawn meanwhile (the cart read after the previous change, the add that
     landed): a line queued for removal does not flash back, a queued size shows. Applied in turn by qRun. */
  function qView(m) {
    if (!tapL.length || !m || !m.groups || !m.groups.length || m.keep) return m;
    var v = m;
    tapL.forEach(function (q) {
      var g = qFind(v, q), b; if (!g || g.pa || g.opt) return;
      if (q.rm) { v = paRe(v, v.groups.filter(function (y) { return y !== g; }), -g.jars, -g.final, -g.was); v.giftLines = gOff(v.giftLines, g); }   /* 20/10 FINAL FIX N2 */
      else if (q.n && q.n !== g.jars && !g.wb && q.n <= maxQ(g)) { b = g.kaching ? bundleItems(g, q.n) : null; v = predict(v, g, q.n, g.kaching ? (b ? b.price : null) : Math.round(g.final / g.jars * q.n)); }
    });
    return v;
  }
  /* 20/10 R1 FIX T1 (taps while a change is saving: 2 requests = 1.5 to 2.5 s at Manila latency). +, -, upgrade and trash tapped
     meanwhile were lost (pointer-events:none): + then - ended at 3 jars, - then trash left 1 jar. Now the drawer shows the tap at once
     (the size it asks for, or the line gone) and the LAST wish is applied, on the real cart, as soon as the save is done: one change at
     a time, the line found again by its bundle id (qMap: old id -> id of the size it was changed to). Same path, without the instant
     view, when another tab changed the cart since this tab read it (FIX X1): the cart is read first, the tap applies to the line if it
     is still there; if not, the drawer just shows the cart. Nothing is ever written on a cart this tab has not read. */
  var dtTap = null, DT_SHIELD = 500, DT_SHIELD_RM = 1000;   /* 20/10 FINAL FIX D1: last drawer control tap (event time + spot). 21/10 R6 FIX D2: trash after trash at the same spot = 1 s */
  var tapQ = null, tapL = [], qMap = {}, qT = 0, coTok = 0, qaW = 0, QA_SHIELD = 1000, rmTs = -1e9;   /* 20/10 R2: tapL = the queued taps (FIX T2), tapQ = the next one; rmTs = event time of the last trash tap (FIX Q2) */
  function qIds(g) { var a = []; if (g.P && g.P.id) a.push(g.P.id); a.push(g.key); return a; }
  function qFind(m, q) {
    var ids = q.ids.slice(), i, x, g = null;
    for (i = 0; i < ids.length && i < 40; i++) { x = qMap[ids[i]]; if (x && ids.indexOf(x) < 0) ids.push(x); }
    m.groups.forEach(function (y) { if (!g && ((y.P && y.P.id && ids.indexOf(y.P.id) > -1) || ids.indexOf(y.key) > -1)) g = y; });
    return g;
  }
  function qTap(k, gi, show) {
    var m = lastM && lastM.groups && lastM.groups.length ? lastM : model(cart), g = k === 'up' ? m.primary : m.groups[gi], q, n;
    if (!g || (g.opt && !g.pa)) return;   /* 20/10 R2 FIX A2: the pending line of a page add takes taps too */
    if (k === 'rm') q = { rm: 1 };
    else { if (g.wb) return; n = g.jars + (k === 'dec' ? -1 : 1); if (n < 1 || n > maxQ(g) || !canQ(g, n)) return; q = { n: n }; }
    q.ids = g.pa ? g.pa.ids.slice() : qIds(g); q.r = 0;   /* 20/10 R2 FIX A2: the pending line = its Kaching bundle id */
    if (show) {
      hideErr();
      if (q.rm) {
        var p = assign({}, m); p.groups = m.groups.filter(function (x) { return x !== g; });
        p.count = m.count - g.jars; p.total = m.total - g.final; p.was = m.was - g.was; p.save = Math.max(0, p.was - p.total);
        p.primary = primOf(p.groups);   /* 20/10 FINAL FIX L1 */
        p.q = p.primary ? Math.min(3, p.primary.jars) : 0; p.sub = !!(p.primary && p.primary.jar && (p.primary.sub || (p.giftLines && p.giftLines.length) || d.documentElement.classList.contains('wh1-nosub')));
        if (p.primary && p.primary.wb) p.q = 3;
        p.giftLines = gOff(m.giftLines, g);   /* 20/10 FINAL FIX N2 */
        if (g.pa) { g.pa.gone = true; p.gdx = 0; }   /* 20/10 R2 FIX A2: the pending line removed now; applied to its bundle once it is in */
        if (!p.groups.length) qaShield = rmTs + QA_SHIELD;   /* 20/10 R2 FIX Q2 */
        render(p);
      } else if (g.pa) { var pv = paSize(m, g, n); render(pv, { fresh: fresh(m, pv) }); }   /* 20/10 R2 FIX A2: the pending line at its new size */
      else {
        var b = g.kaching ? bundleItems(g, n) : null, nm = predict(m, g, n, g.kaching ? (b ? b.price : null) : Math.round(g.final / g.jars * n));
        render(nm, { fresh: fresh(m, nm) });
      }
    }
    tapL = tapL.filter(function (x) { return !x.ids.some(function (y) { return q.ids.indexOf(y) > -1; }); }); tapL.push(q); tapQ = tapL[0];   /* 20/10 R2 FIX T2: same line = the last wish; another line waits its turn */
    qWait();
  }
  function qIdle() { return !busy && !swapRun && !opt && !addOut() && !loading && !(afRd > 0) && !undoQ && !paLive(); }   /* 20/10 R2 FIX A2: + a pending line still waiting for its cart */
  function qWait() {
    clearTimeout(qT); var n = 0;
    (function w() { if (!tapQ) return; if (qIdle()) { qRun(); return; } if (++n < 300) { qT = setTimeout(w, 100); return; } tapL = []; tapQ = null; if (isOpen) render(keptM || model(cart)); })();   /* 30 s cap: dropped, the drawer shows the cart */
  }
  function qRun() {
    var q = tapQ; if (!q) return;
    if (!qIdle()) { qWait(); return; }
    tapL.shift(); tapQ = tapL[0] || null; clearTimeout(qT);   /* 20/10 R2 FIX T2: the next queued tap (another line) waits its turn */
    var act = function () {
      if (tapL.some(function (t) { return t.ids.some(function (x) { return q.ids.indexOf(x) > -1; }); })) { qWait(); return; }   /* a newer tap on the same line (made on the view that showed this one): it decides */
      var m = model(cart), g = qFind(m, q);
      if (!g || (q.n && (g.wb || q.n > maxQ(g)))) { if (isOpen) render(m); if (tapQ) qWait(); return; }   /* the line is not in the cart any more: the drawer shows the cart (+ the taps still queued) */
      var gi = m.groups.indexOf(g);
      if (q.rm) removeGroup(gi); else if (q.n !== g.jars) setQ(gi, q.n); else if (isOpen) render(m);
      if (tapQ) qWait();   /* 20/10 R2 FIX T2 */
    };
    if (cart && cart.__g === wg && !cwOther()) { act(); return; }   /* the cart read after the last write of this tab, no other tab since */
    busy++; busyUI(true);
    fetchCart().then(function (c) {
      busy--; busyUI(false);
      if (!setCart(c) && q.r++ < 3) { if (!tapL.some(function (t) { return t.ids.some(function (x) { return q.ids.indexOf(x) > -1; }); })) tapL.unshift(q); tapQ = tapL[0] || null; qWait(); return; }   /* a write started meanwhile: wait for it, read again (20/10 R2: back at the head of the queue) */
      act();
    }, function () {
      busy--; busyUI(false);
      if (q.r++ < 3) { if (!tapL.some(function (t) { return t.ids.some(function (x) { return q.ids.indexOf(x) > -1; }); })) tapL.unshift(q); tapQ = tapL[0] || null; clearTimeout(qT); qT = setTimeout(qWait, 600 * q.r); return; }   /* 20/10 FINAL FIX Q3 (r11258A): the read failed (429, network): the tap stays queued (the drawer keeps showing it), the cart is read again. Was: the tap dropped, the old cart drawn */
      toast('Could not update your cart. Please try again.'); if (isOpen) render(keptM || model(cart)); if (tapQ) qWait();   /* 3 reads failed: dropped, said */
    });
  }
  /* 20/10 R1 FIX W2: the /cart.js read after a +, -, upgrade or trash failed (429, network) and the next one too: the cache stayed on the
     old cart (header badge, a reopen, the checkout compare) and, after a trash, a failed read drew the removed line again. /cart/update.js
     and /cart/change.js answer with the whole cart: that answer is the cart, if nothing was written since (write generation unchanged). */
  function wjUse(j, g, q) {   /* 21/10 R7: q = not drawn now (another change is saving: its own read draws) */
    if (!j || !j.items || j.token == null || j.item_count == null || g !== wg) return false;
    try { Object.defineProperty(j, '__s', { value: ++rdSeq }); Object.defineProperty(j, '__g', { value: g }); Object.defineProperty(j, '__cw', { value: cwGet() }); } catch (e) { }
    if (!setCart(j)) return false;
    if (!q && isOpen && !opt) render(model(j));
    return true;
  }
  /* 20/10 R1 FIX C4: a checkout still waiting (a change saving) is cancelled by a new change tapped in the drawer */
  function coCancel() { coTok++; clearInterval(coI); clearTimeout(coT); var cb = E.ft && E.ft.querySelector('.whc__co.is-go'); if (cb) cb.classList.remove('is-go'); }
  /* 20/10 R1 FIX Q1: the empty card's Add tapped while the removal (or Undo, a queued tap, the gifts clean-up) is saving: done right after
     it (the button keeps its existing disabled look meanwhile), only if the cart is still empty then. Was (v3): the tap was lost. */
  function qaLater(a) {
    if (qaW) return; qaW = 1; a.disabled = true;
    var n = 0;
    (function w() {
      if ((busy || swapRun || tapQ || undoQ || ensureGiftsRunning || ensureShipRunning || addOut() || paLive()) && ++n < 300) { setTimeout(w, 100); return; }   /* 20/10 R2: + a page add still out */
      qaW = 0;
      var b = (root && root.querySelector('[data-whc="qa"]')) || a; b.disabled = false; a.disabled = false;
      if (model(cart).groups.length) return;   /* the line is back (Undo, a removal that did not go through): nothing to add */
      if (removed) { removed = null; undoQ = false; hideToast(); }   /* the visitor adds again: no Undo on top of it */
      qaAdd(b);
    })();
  }
  function busyUI(on) { if (root) root.classList.toggle('is-busy', !!on); }
  function setQ(gi, n) {
    var m = model(cart), g = m.groups[gi];
    if (!g || busy || n < 1 || n > maxQ(g) || n === g.jars) return;
    if (g.wb) return;   /* OFFER B: 1 jar, no resize */
    var prev = m, step;
    hideErr(); wBump();   /* 20/10: an old add error does not stay above a working change (FIX E1); a write starts (FIX S1) */
    if (g.kaching) {
      var b = bundleItems(g, n);
      if (!b && g.jar) { kNeed(); if (isOpen && !opt) render(keptM || model(cart)); return; }   /* 20/10 R4 FIX K1: no bar of that size in the line's own deal (a queued tap, data not in yet): nothing is written, no jump to the product page */
      if (!b) { location.href = (g.url ? g.url.split('?')[0] : CFG.shopUrl || '/products/wildhorn-bison') + '#offer'; return; }
      if (g.P && g.P.id) qMap[g.P.id] = b.id;   /* 20/10 R1 FIX T1: a tap queued on this line finds it under its new bundle id */
      var nm = predict(m, g, n, b.price);
      render(nm, { fresh: fresh(prev, nm) });
      var kill = groupLines(g).keys, back2 = restoreItems(g), added = false;
      /* add the new bundle first, then remove the old lines: a failed add leaves the cart untouched.
         20/10 FIX W1: the swap is written down first. 2nd request lost (429, network, the add's answer lost): the old lines are removed
         again as soon as the new bundle is seen in the cart (here; Back / closed app: next page, next refresh, checkout). The toast
         only when that fails too (the drawer then shows both lines). */
      swapSave({ id: b.id, kill: kill, t: Date.now() });
      step = post('/cart/add.js', { items: b.items }).then(function () {
        added = true;
        var upd = {}; kill.forEach(function (k) { upd[k] = 0; });
        return post('/cart/update.js', { updates: upd });
      }).then(function (j) { swapSave(null); return j; }).catch(function (e) {
        if (!added && e && e.status) swapSave(null);   /* Shopify answered the add with an error: nothing was added */
        return (swapGet() ? swapFix() : Promise.resolve('none')).then(function (r) {
        if (r === 'done') return;   /* the swap is finished: the cart holds the new size only */
        toast(e && e.status === 422 ? 'Sorry, that bundle is not available right now.' : 'Could not update your cart. Please try again.');
        return fetchCart().then(function (c) {
          /* old lines gone but the new bundle missing: put the old bundle back */
          var still = c.items.some(function (i) { return kill.indexOf(i.key) > -1; });
          if (!still && !c.items.some(function (i) { return !isHidden(i.handle); })) { swapSave(null); return post('/cart/add.js', { items: back2 }).catch(function () { }); }
        });
        });
      });
    } else {
      var line = g.lines[0];
      render(predict(m, g, n, Math.round(g.final / g.jars * n)), {});
      step = post('/cart/change.js', { id: line.key, quantity: n }).catch(function (e) { toast(e && e.message && e.status === 422 ? esc(e.message) : 'Could not update your cart. Please try again.'); });
    }
    busy++; busyUI(true);
    var wj = null, wg0 = wg;   /* 20/10 R1 FIX W2 */
    step.then(function (j) { wj = j; return fetchCart(); }).then(function (c) {
      busy--; busyUI(false);
      if (!setCart(c)) return;   /* 20/10 FIX S1: a page add started meanwhile: its own read draws */
      if (tapQ) { qRun(); return; }   /* 20/10 R1 FIX T1: a tap made while this change was saving: applied now, on this cart (no flash of the in-between size) */
      var m2 = model(c), g2 = m2.primary;
      render(m2, { fresh: fresh(lastM, m2) });   /* gifts already animated by the optimistic render */
      if (onPdp() && g2 === m2.groups[gi]) syncPdp(g2.jars);
      var fg = fresh(prev, m2).length;
      if (g2) say(jarsWord(g2.jars) + ', ' + money(g2.final) + (fg ? '. ' + fg + ' more FREE gift unlocked.' : '.'));
      ensureGifts(c).then(ensureShipping).then(function (c2) { if (c2 && c2 !== c && !busy && !opt && (c2.item_count !== c.item_count || c2.total_price !== c.total_price) && setCart(c2) && isOpen) render(model(c2)); });   /* 20/10 FINAL FIX G2: the guide rule after every resize (2 -> 1 jar: no guide) */
    }).catch(function () { busy--; busyUI(false); wjUse(wj, wg0); rfh(); });   /* 20/10 R1 FIX W2: the read after the change failed: the change's own answer is the cart. R4 FIX F2: still unreadable: read again later */
  }
  function removeGroup(gi) {
    var m = model(cart), g = m.groups[gi];
    if (!g || busy) return;
    hideErr(); wBump(); undoQ = false;   /* 20/10 FIX E1 / S1 */
    var gl = groupLines(g), items = restoreItems(g), name = g.name;
    var upd = {}; gl.keys.forEach(function (k) { upd[k] = 0; });
    /* optimistic: the line disappears now */
    var p = assign({}, m); p.groups = m.groups.filter(function (x) { return x !== g; });
    p.count = m.count - g.jars; p.total = m.total - g.final; p.was = m.was - g.was; p.save = Math.max(0, p.was - p.total);
    p.primary = primOf(p.groups);   /* 20/10 FINAL FIX L1 */
    p.q = p.primary ? Math.min(3, p.primary.jars) : 0; p.sub = !!(p.primary && p.primary.jar && (p.primary.sub || (p.giftLines && p.giftLines.length) || document.documentElement.classList.contains('wh1-nosub')));
    if (p.primary && p.primary.wb) p.q = 3;   /* OFFER B */
    p.giftLines = gOff(m.giftLines, g);   /* 20/10 FINAL FIX N2 */
    render(p);
    removed = { items: items, name: name, keys: g.lines.map(function (it) { return it.key; }), before: m.count, m: m, jars: g.jars };   /* 20/10 FIX U3: what Undo checks before adding back. R4: + the cart before the tap (FIX U5) */
    if (!p.groups.length) qaShield = rmTs + QA_SHIELD;   /* 20/10 FIX U1: the empty card's Add sits under the trash: not the 2nd tap of a double tap. R2 FIX Q2: counted from the trash tap (event time): a removal queued behind a +/- and sent later does not arm it again */
    toast(esc(name) + ' removed.', true); say(name + ' removed from your cart.');
    clearTimeout(E.toast._h);   /* 20/10 FIX U2: the toast stays while saving; 5 s from the end of the save */
    setTimeout(function () { var u = E.toast.querySelector('button'); if (u) u.focus({ preventScroll: true }); }, 30);
    busy++; busyUI(true);
    var rearm = function () { if (removed && E.toast.querySelector('[data-whc="undo"]')) toastArm(5000); };
    var ru = null, rg0 = wg, uf = null, rr = removed;   /* 20/10 R1 FIX W2. R4 FIX F1: uf = the removal's own error (was swallowed), rr = this removal */
    var gone = function (c) { return !!(c && c.items && !c.items.some(function (i) { return rr.keys.indexOf(i.key) > -1; })); };
    post('/cart/update.js', { updates: upd }).then(function (j) { ru = j; if (gone(j)) rr.ok = 1; }, function (e) { uf = e || {}; }).then(function () { return uf ? rdTry(2) : fetchCart(); }).then(function (c) {
      busy--; busyUI(false);
      var ok = setCart(c); if (ok) render(model(c));   /* 20/10 FIX S1 */
      if (ok && removed && c.items.some(function (i) { return (removed.keys || []).indexOf(i.key) > -1; })) { removed = null; undoQ = false; toast('Could not update your cart. Please try again.'); return; }   /* 20/10 FIX U3: the removal did not go through: no Undo */
      if (ok && gone(c)) rr.ok = 1;   /* 20/10 R4: the removal is known done (FIX U4) */
      if (undoQ) { undoQ = false; undo(); return; }   /* 20/10 FIX U2: the Undo tapped while saving runs now */
      rearm();
      if (ok) ensureGifts(c).then(ensureShipping).then(function (c2) { if (c2 && c2 !== c && !busy && setCart(c2) && isOpen) render(model(c2)); });
    }).catch(function () {
      busy--; busyUI(false);
      if (uf) {   /* 20/10 R4 FIX F1 (hard verifier: the removal failed and 3 reads too): no "removed. Undo" over a line that is still there (its Undo added a 2nd bundle): the error, the cart as it was, read again later */
        if (removed === rr) { removed = null; undoQ = false; }
        toast('Could not update your cart. Please try again.');
        if (isOpen && !opt) render(keptM || model(cart));
        heal(); return;
      }
      wjUse(ru, rg0); if (undoQ) { undoQ = false; undo(); } else rearm(); rfh();   /* 20/10 R1 FIX W2 */
    });
  }
  function undo() {
    if (!removed) return;
    if (busy || ensureGiftsRunning || ensureShipRunning || addOut()) {   /* 20/10 FIX U2: tapped while the removal (or a gifts pass) is saving: queued, not dropped */
      if (!undoQ) {
        undoQ = true; clearTimeout(E.toast._h);
        var u = E.toast.querySelector('[data-whc="undo"]'); if (u) { u.setAttribute('aria-disabled', 'true'); u.style.opacity = '.55'; }
        (function w(n) { if (!undoQ) return; if ((busy || ensureGiftsRunning || ensureShipRunning || addOut()) && n < 300) { setTimeout(function () { w(n + 1); }, 100); return; } undoQ = false; undo(); })(0);
      }
      return;
    }
    var r = removed; removed = null; hideToast();
    var sure = !!(cart && cart.__g === wg && !addOut() && !cwOther());   /* the cart read after the removal, nothing written since */
    hideErr(); wBump();   /* 20/10 FIX E1 / S1 */
    busy++; busyUI(true); loading = true;
    if (!model(cart).groups.length) render(model(cart));
    /* 20/10 FIX U3: added back only if it is not back already (a removal that did not go through, the same jars added again): never a 2nd copy */
    var conf = !!(r.ok && !addOut() && !cwOther());   /* 20/10 R4 FIX U4: the removal is known done (its answer, or a read without the line), nothing added since */
    var put = function () { return post('/cart/add.js', { items: r.items }).then(function () { r.put = 1; }, function () { r.put = -1; toast('Could not restore it. Please add it again.'); }); };
    (sure ? Promise.resolve(cart) : rdTry(2)).then(function (c) {
      if (c.items.some(function (i) { return (r.keys || []).indexOf(i.key) > -1; }) || model(c).count >= r.before) return;
      return put();
    }, function () {   /* 20/10 R4 FIX U4 (hard verifier: failed trash + failed reads, then Undo = 2 bundles): the cart cannot be read (3 tries): added back only when the removal is known done, never blind */
      if (conf) return put();
      r.put = -1; toast('Could not restore it. Please add it again.');
    }).then(function () { return r.put === 1 ? rdTry(2) : fetchCart(); }).then(function (c) {
      busy--; busyUI(false); loading = false; var ok = setCart(c); if (ok) render(model(c));
      if (r.put !== -1) say(r.name + ' is back in your cart.');
      var rm = root.querySelector('[data-whc="rm"]'); if (rm) rm.focus({ preventScroll: true });
      if (ok) ensureGifts(c).then(ensureShipping).then(function (c2) { if (c2 && c2 !== c && !busy && !opt && (c2.item_count !== c.item_count || c2.total_price !== c.total_price) && setCart(c2) && isOpen) render(model(c2)); });   /* 20/10 R4 FIX G3: the guide rule after an Undo too (fs30015A) */
    }).catch(function () {
      busy--; busyUI(false); loading = false;
      if (r.put === 1 && r.m && model(cart).count === r.m.count - r.jars) { keptM = r.m; badge(r.m.count); }   /* 20/10 R4 FIX U5 (fuzz fz20350PC): the Undo's add went through, the cart cannot be read: the bundle is drawn back (was: the empty cart, badge empty) until a real read */
      if (isOpen && !opt) render(keptM || model(cart));
      rfh();
    });
  }
  /* product page (port of product-v6): mirror a bundle change made in the cart onto the page picker */
  function syncPdp(q) {
    var b = d.querySelector('.qty--of8 button[data-q="' + q + '"]');
    if (b && !b.classList.contains('on')) b.click();
  }
  function checkout() {
    clearInterval(coI); clearTimeout(coT);   /* 20/10 FIX C1: one pending checkout at a time, both timers stopped when it leaves */
    var cb = E.ft && E.ft.querySelector('.whc__co'); if (cb) cb.classList.add('is-go');
    var shown = (lastM || keptM || model(cart)).count;   /* 20/10 FIX C1: the jars the drawer shows at the tap */
    var tok = ++coTok, t0 = Date.now(), rs0 = rdSeq, sw0 = swapRun ? -1 : swapRuns;   /* 21/10 R7 FIX C5: reads asked after the tap, swap repairs since the tap */
    var go = function () {
      clearInterval(coI); clearTimeout(coT);
      if (tok !== coTok) return;
      if (sw0 === swapRuns && (keptM || model(cart)).count === shown && !cwOther()) { location.href = '/checkout'; return; }   /* 21/10 R7 FIX C5b: after a swap repair the cart is read once (below) */
      /* 20/10 R1 FIX C2: the cached cart says other jars than the drawer showed (its read after a +/- failed, another tab, an add that
         landed or failed): read the cart once. Same jars: go. Other jars: the drawer shows them, the next tap goes. Unreadable: go, as
         v2 did (the checkout page lists the real cart). Was (v3): the tap was dropped when the read after a + had failed. */
      fetchCart().then(function (c) {
        if (tok !== coTok) return;
        var ok = setCart(c), m2 = model(c);
        if (m2.count === shown) { location.href = '/checkout'; return; }
        if (cb) cb.classList.remove('is-go');
        if (ok && swapNeed(c) && !busy && !swapRun) { swapFix().then(function () { if (isOpen && !busy && !opt) render(keptM || model(cart)); }); return; }   /* 22/10 R7 FIX C5d: a half-done + (its removal lost): finished first, the drawer shows the result, the next tap goes */
        if (ok && isOpen && !busy && !opt) render(m2);
      }, function () {
        if (tok !== coTok) return;
        if (!keptM && cart && cart.__s > rs0 && cart.__g === wg && model(cart).count !== shown) { if (cb) cb.classList.remove('is-go'); if (isOpen && !busy && !opt) render(model(cart)); return; }   /* 21/10 R7 FIX C5c: the cart answered after the tap has other jars: shown, the next tap goes */
        location.href = '/checkout';
      });
    };
    if (!busy && !swapRun && swapGet()) swapFix();   /* 20/10 FIX W1: a resize left half done is finished first */
    /* 19/10 FIX B2: also waits for the B cart guard, and on a B cart for a /cart.js read still out or a gifts pass running (a doubled
       B cart that appeared after the page load is only seen, and fixed, once that read answers) */
    var hold = function () { return busy || opt || bfRun || swapRun || undoQ || tapQ || addOut() || afRd > 0 || ensureGiftsRunning || (rdN > 0 && cartB(cart)); };   /* 20/10 FIX W1/U1/U2; R1 FIX T1: a queued tap too */
    if (!hold()) return go();
    coI = setInterval(function () { if (!hold()) go(); }, 120);
    coT = setTimeout(function fb() {   /* 20/10 R1 FIX C3: the 6 s fallback never leaves while a change is still saving (cap 20 s); a pending add: the 120 ms poll goes once it is in */
      if (tok !== coTok) return;
      if ((opt || swapRun || busy || tapQ) && Date.now() - t0 < 20000) { coT = setTimeout(fb, 300); return; }
      if (opt) return;
      clearInterval(coI); go();
    }, 6000);
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-whc-close]')) { close(); return; }
    var a = t.closest('[data-whc]');
    if (!a || a.disabled) return;
    var k = a.getAttribute('data-whc');
    if (opt && k !== 'shop' && k !== 'co') return;   /* optimistic line: nothing to change until the real cart is in. 20/10 R2 FIX A2: a page add still out (FIX U1) no longer drops the tap: +, -, upgrade, trash are queued below, Undo and the empty card's Add wait for it */
    if (keptM && /^(inc|dec|up|rm)$/.test(k)) { refresh(); return; }   /* 20/10 FIX S2: the kept line is not the cart yet: read it first */
    if (/^(inc|dec|up|rm)$/.test(k) && atcTap && e.isTrusted && Math.abs(e.clientX - atcTap.x) < 44 && Math.abs(e.clientY - atcTap.y) < 44 && Date.now() - atcTap.t < 8000 && (Date.now() - atcTap.t < 1500 || Date.now() - addDrawT < 1500)) return;   /* 20/10 FIX R1: the 2nd tap of a double tap on Add to cart, landed on the drawer: no resize, no removal */
    if (/^(inc|dec|up|rm)$/.test(k) && e.isTrusted) {   /* 20/10 FINAL FIX D1 (verifier R2: a double tap on the trash with 2 bundles removed both, v2 one): the 2nd tap of a double tap on a drawer control (same spot, < 500 ms event time) is ignored, like FIX R1 / Q2 */
      var et = evTs(e);
      if (dtTap && et >= dtTap.t && et - dtTap.t < (k === 'rm' && dtTap.k === 'rm' ? DT_SHIELD_RM : DT_SHIELD) && Math.abs(e.clientX - dtTap.x) < 44 && Math.abs(e.clientY - dtTap.y) < 44) return;   /* 21/10 R6 FIX D2 (slow double tap on the trash: 1 s) */
      dtTap = { t: et, x: e.clientX, y: e.clientY, k: k };
    }
    if (k === 'rm') rmTs = evTs(e);   /* 20/10 R2 FIX Q2 */
    if (/^(inc|dec|up|rm|undo|qa)$/.test(k)) coCancel();   /* 20/10 R1 FIX C4: a change tapped after SECURE CHECKOUT (while it waits) cancels that checkout: the visitor sees the new cart, the next tap goes */
    var qw = busy || swapRun || tapQ || addOut() || paLive() || paOn();   /* 20/10 R2 FIX A2: + a page add still out, a pending line on screen */
    if (/^(inc|dec|up|rm)$/.test(k) && (qw || cwOther())) { qTap(k, +a.getAttribute('data-g') || 0, !!qw); return; }   /* 20/10 R1 FIX T1 / X1: queued (shown now, applied once the save is done), or the cart read first (another tab changed it) */
    var gi = +a.getAttribute('data-g') || 0, m = model(cart), g = m.groups[gi];
    if (k === 'inc' && g) setQ(gi, g.jars + 1);
    else if (k === 'dec' && g) setQ(gi, g.jars - 1);
    else if (k === 'up' && m.primary) setQ(m.groups.indexOf(m.primary), m.primary.jars + 1);
    else if (k === 'rm' && g) removeGroup(gi);
    else if (k === 'undo') undo();
    else if (k === 'co') checkout();
    else if (k === 'qa') { if (evTs(e) < qaShield) return; if (busy || swapRun || tapQ || undoQ || ensureGiftsRunning || ensureShipRunning || addOut() || paLive()) { qaLater(a); return; } qaAdd(a); }   /* 20/10 FIX U1: not the 2nd tap of a double tap on the trash. R1 FIX Q1: tapped while a change is saving = done right after it (v3 dropped it) */
    else if (k === 'shop') {
      var o = d.getElementById('offer');
      if (o && location.pathname === String(a.getAttribute('href') || '').split('#')[0]) {
        e.preventDefault(); close(); o.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
  function onChange(e) {
    var t = e.target;
    if (t && t.getAttribute('data-whc') === 'ship') toggleShipping(t.checked);
  }
  /* offer changes on the product page: refresh the hidden pre-render (debounced, idle) */
  function onPageOffer(e) { var t = e.target; if (W.WH1P && !isOpen && t && t.closest && t.closest('.wh1-pc')) schedPrewarm(); }
  d.addEventListener('click', onPageOffer, { passive: true });
  d.addEventListener('change', onPageOffer, { passive: true });

  /* ---- page hooks (previous drawer): add-to-cart detection + cart links ---- */
  /* 1) window.fetch override: string URLs AND Request objects */
  W.fetch = function () {
    var a = arguments[0];
    var url = (typeof a === 'string') ? a : (a && a.url ? a.url : String(a || ''));
    if (url.indexOf('/cart/add') > -1) {
      var internal = false;   /* 20/10 FIX U1: no "|| busy". 20/10 R1 FIX M1: nor "ensureGiftsRunning || ensureShipRunning": the gifts and shipping passes write through origFetch, never through this hook, so an add seen here is always a page / app add (an Add tapped during the gifts clean-up got "Sorry, that did not go through" although it went through) */
      /* the request leaves first: no drawer work before it (instant cart 27-09) */
      var pr = origFetch.apply(this, arguments);
      addFly++; addSeq++; addT0 = Date.now(); var fd = function () { addFly--; addEnd = Date.now(); if (!addFly && root) pendUI(lastM); }; pr.then(fd, fd);   /* 19/10 FIX B3: page adds (this hook only sees page / app requests) */
      if (!internal) { wBump(); if (root) pendUI(lastM); }   /* 20/10 FIX S1 / U1 */
      if (!internal && opt && !opt.req && !busy) {
        var o = opt; bindAdd(o); optIds(o, arguments[1] && arguments[1].body);
        return pr.then(function (res) { addDone(o, !!(res && res.ok)); return res; }, function (err) { addDone(o, false); throw err; });
      }
      if (!internal && opt && opt.req && !busy && !paLive()) paNew(arguments[1] && arguments[1].body, pr);   /* 20/10 R2 FIX A2: an add sent while another one holds the instant view: its own pending line */
      if (!internal && busy && !(W.__whGo && Date.now() - W.__whGo < 20000)) {   /* 20/10 FIX U1: drawn once the change being saved is done */
        loading = true; if (isOpen) render(lastM || model(cart));
        var late = function () { idleDo(lateAdd); };
        return pr.then(function (res) { late(); return res; }, function (err) { late(); throw err; });
      }
      if (!internal && !opt) openLoading();
      /* 09-10 tracking: Shopify's add-to-cart listener (inner) already has the answer; Kaching gets it 500 ms later, so the AddToCart event
         (Aimerce -> Meta) leaves before checkout opens. Before, the redirect started at once and Aimerce's request was cut. */
      if (!internal && (W.__whGo&&Date.now()-W.__whGo<20000)) return pr.then(function (res) { if (!(res && res.ok)) { W.__whGo = 0; return res; } return new Promise(function (ok) { setTimeout(function () { location.href = '/checkout'; ok(res); }, 500); }); }, function (err) { W.__whGo = 0; throw err; });
      return pr.then(function (res) { if (!internal) afterAdd(); return res; }, function (err) { if (!internal) afterAdd(); throw err; });
    }
    return origFetch.apply(this, arguments);
  };
  /* 2) XMLHttpRequest: many apps add via XHR, which the fetch override never sees */
  (function () {
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__cdAdd = (typeof u === 'string' && u.indexOf('/cart/add') > -1); return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (x.__cdAdd && (W.__whGo&&Date.now()-W.__whGo<20000) && !(ensureGiftsRunning || ensureShipRunning || busy)) { x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) location.href = '/checkout'; else W.__whGo = 0; }); return _send.apply(x, arguments); }
      if (x.__cdAdd) {
        cwBump(); wBump();   /* 20/10 FIX S1; R1 FIX X1 / M1 */
        if (!busy && opt && !opt.req) {   /* 20/10 R1 FIX M1 */
          var o = opt; bindAdd(o);
          x.addEventListener('load', function () { addDone(o, x.status >= 200 && x.status < 300); });
          x.addEventListener('error', function () { addDone(o, false); });
          x.addEventListener('abort', function () { addDone(o, false); });
        } else x.addEventListener('load', function () { if (busy) idleDo(lateAdd); else { if (!opt) openLoading(); afterAdd(); } });   /* 20/10 FIX U1; R1 FIX M1 */
      }
      return _send.apply(this, arguments);
    };
  })();
  /* 2b) instant cart: Add to cart on the product page facade (window capture: runs before the facade's own handler) */
  W.addEventListener('click', onAtcClick, true);
  /* 3) native product <form action="/cart/add"> submit (Kaching fills the form, the drawer posts it) */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented) return;   /* a theme / app form handler already posts it (no double add) */
    if (f && f.action && String(f.action).indexOf('/cart/add') > -1) { e.preventDefault(); W.fetch('/cart/add.js', { method: 'POST', body: new FormData(f) }).catch(function () { }); }
  });
  /* 4) cart icon / cart links / [data-cart-open] open the drawer instead of going to /cart */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"], [data-cart-open]');
    if (!link || (root && root.contains(link))) return;
    var isCartLink = link.tagName === 'A' && link.href && link.href.indexOf('/cart/') === -1 && link.href.indexOf('checkout') === -1;
    if (isCartLink || link.hasAttribute('data-cart-open')) { e.preventDefault(); e.stopImmediatePropagation(); open(link); refresh(); }
  }, true);
  /* 5) other scripts: document.documentElement.dispatchEvent(new Event('cart:open')) */
  d.documentElement.addEventListener('cart:open', function () { open(); refresh(); });
  d.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')).filter(function (x) { return x.offsetWidth || x.offsetHeight || x.getClientRects().length; });
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], act = d.activeElement;
    if (e.shiftKey && (act === first || !panel.contains(act) || act === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (act === last || !panel.contains(act))) { e.preventDefault(); first.focus(); }
  });
  addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  /* 20/10 R1 FIX X1: another tab wrote the cart: an open drawer reads it (debounced) so it never shows a cart that is gone; closed: the
     cart is read for the header badge only (no gifts pass: no write from this tab) */
  var cwT = 0;
  function cwSync() {
    clearTimeout(cwT);
    cwT = setTimeout(function () {
      if (!cwOther() || busy || opt || tapQ || swapRun) return;
      if (isOpen) refresh(); else fetchCart().then(function (c) { if (!busy && !opt) setCart(c); }, function () { });
    }, 150);
  }
  addEventListener('storage', function (e) { if (e.key === CWK) cwSync(); });
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'visible') cwSync(); });

  /* previous drawer API names */
  W.cdOpen = function () { open(); };
  W.cdOpenLoading = openLoading;
  W.cdClose = close;
  W.cdRefresh = function (openAfter) { if (openAfter) open(); return refresh(); };
  W.cdChangeQty = function (key, qty) {
    busy++; wBump();   /* 20/10 FIX S1 */
    return post('/cart/change.js', { id: key, quantity: qty }).catch(function () { }).then(function () { busy--; return refresh(); });
  };
  W.cdRemoveKeys = function (csv) {
    var upd = {}; String(csv || '').split('|').filter(Boolean).forEach(function (k) { upd[k] = 0; });
    busy++; wBump();   /* 20/10 FIX S1 */
    return post('/cart/update.js', { updates: upd }).catch(function () { }).then(function () { busy--; return refresh(); });
  };
  W.cdToggleShipping = function (cb) { return toggleShipping(!!(cb && cb.checked)); };

  function init() {
    kHarvest();
    build();
    patchShell();
    if (cart) badge(model(cart).count);
    /* on load: clean orphan gifts / shipping if there is no paid item (previous drawer) */
    var ld = function (c) {
      if (!setCart(c)) return;   /* 20/10 FIX S1: an add made before this answer came back: its own read is newer */
      if (swapNeed(c)) { swapFix().then(function () { refresh(); }); return; }   /* 20/10 FIX W1: a resize left half done on the page before */
      var hasPaid = c.items.some(function (i) { return !isHidden(i.handle); });
      if (!hasPaid && c.items.length) ensureGifts(c).then(ensureShipping).then(function (c2) { if (setCart(c2) && isOpen) render(model(c2)); });
      else if (hasPaid) ensureGifts(c).then(function (c2) { if (c2 && c2 !== c && setCart(c2) && isOpen && !busy && !opt) render(model(c2)); });   /* 19/10 FIX B2 (B cart guard). 20/10 FINAL FIX G2: + the guide rule on every paid cart (a v2 cart can hold the guide with 1 jar) */
    };
    fetchCart().then(ld).catch(function () { setTimeout(function () { fetchCart().then(ld).catch(function () { }); }, 1500); });   /* 20/10 FINAL FIX I1: a failed page-load read (429, 500, network) is retried once: the badge and the cache were left on the server-rendered cart */
    qaResume();   /* 18/10 empty cart: the offer card was tapped on another page */
    /* idle: scrollbar width (used when the drawer opens) + first pre-render of the offer line */
    var idle = function () { (W.requestIdleCallback || function (f) { return setTimeout(f, 1); })(function () { measureSbw(); schedPrewarm(0); }, { timeout: 2500 }); };
    if (d.readyState === 'complete') idle(); else addEventListener('load', idle);
    var rsT = 0;
    addEventListener('resize', function () { sbw = null; clearTimeout(rsT); rsT = setTimeout(function () { if (!saved) measureSbw(); }, 400); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  W.WHCart = {
    shopify: true,
    open: function () { open(); refresh(); }, close: close,
    refresh: function () { return refresh(); },
    get: function () { return cart; },
    model: function () { return model(cart); },
    pending: function () { return !!opt; },
    ver: 'v3r7p'   /* 23/10 v3plus (PayPal icon out); 20/10 R4: served-file check (push_v3.py), survives the minifier. 21/10 R5, R6, 22/10 R7 */
  };
})();
